export const ru = {
  "profile.phone": "Телефон",
  "profile.phoneInvalid": "Введите от 7 до 15 цифр, можно с + в начале.",
  "common.scrollableTable": "Таблица с горизонтальной прокруткой",
  "auth.ecpAccountLogin": "Логин учётной записи компании (если у вас несколько аккаунтов)",
  "layout.currentCompany": "Текущая компания",
  "auth.accountUnavailable": "Не удалось войти. Проверьте логин, пароль и доступность учётной записи.",
  "documentUpload.selectSingle": "Выберите файл или перетащите его сюда",
  "documentUpload.selectMultiple": "Выберите файлы или перетащите их сюда",
  "documentUpload.requirements":
    "Поддерживаются PDF, DOC и DOCX. Максимальный размер одного файла — 20 МБ.",
  "documentUpload.unsupportedType":
    "Файл «{name}» имеет неподдерживаемый формат. Выберите PDF, DOC или DOCX.",
  "documentUpload.emptyFile": "Файл «{name}» пуст и не может быть загружен.",
  "documentUpload.fileTooLarge":
    "Размер файла «{name}» превышает допустимые 20 МБ.",
  "documentUpload.uploadFailed":
    "Не удалось загрузить файл. Проверьте формат и размер файла.",
  // Общие
  "common.yes": "Да",
  "common.no": "Нет",
  "common.actions": "Доступные действия",
  "common.copyId": "Копировать полный ID",
  "common.showFullId": "Показать или скрыть полный ID",
  "common.idCopied": "Полный ID скопирован",
  "common.idCopyFailed": "Не удалось скопировать ID. Раскройте его и скопируйте вручную.",
  "common.createdAt": "Дата создания",
  "common.updatedAt": "Дата обновления",

  // ProcessUserDetails
  "process.returnForRework": "Вернуть на доработку",
  "process.deny": "Отказать",
  "process.edit": "Редактировать",
  "process.send": "Отправить",
  "process.return": "Вернуть",
  "process.delete": "Удалить",
  "process.createLinkedDocument": "Создать связанный документ",
  "process.signed": "Подписано",
  "process.signWithEcp": "Подписать с ЭЦП",
  "process.comments": "Комментарии",
  "process.info": "Информация о процессе",
  "process.name": "Название",
  "process.executor": "Исполнитель",
  "process.comment": "Комментарий",
  "process.status": "Статус",
  "process.noData": "Нет данных",
  "process.tab.requisites": "Реквизиты",
  "process.tab.content": "Содержимое",
  "process.tab.attachments": "Приклепления",
  "process.tab.processes": "Процессы",
  "process.tab.history": "Истории",
  "process.tab.accessRights": "Права доступа",
  "process.tab.linkedDocuments": "Связанные документы",
  "process.access.view": "Просмотр",
  "process.access.creator": "Создатель",
  "process.started": "Процесс запущен",
  "process.execute": "Выполнить задание",
  "process.signingMethod": "Способ подписания",
  "process.signingSessionsLoading": "Проверяем активные сессии подписания...",
  "process.signingSessionsError":
    "Не удалось проверить активную сессию. Обновите страницу перед подписанием.",
  "process.selectSigningMethod": "Выберите способ подписания",
  "process.ncaLayerOption": "NCALayer — ключ ЭЦП на компьютере",
  "process.egovMobileOption": "eGov Mobile — QR-код в мобильном приложении",
  "process.activeMobileSession":
    "Создана активная сессия eGov Mobile. Завершите её перед использованием NCALayer.",
  "process.ncaManifestSigning": "Подписание пакета через NCAManifest.xml",
  "process.packageSigned": "Пакет подписан",
  "process.waitingNcaLayer": "Ожидаем NCALayer...",
  "process.signWithNcaLayer": "Подписать",
  "process.ncaLayerHint":
    "Подписание пакета документов (NCAManifest.xml) ключом ЭЦП на компьютере через NCALayer.",
  "process.egovMobileHintMobile":
    "Подписание в приложении eGov Mobile. После создания сессии нажмите «Открыть в eGov Mobile».",
  "process.egovMobileHintDesktop":
    "Подписание через QR-код в мобильном приложении eGov Mobile.",
  "process.openEgovMobile": "Открыть в eGov Mobile",
  "process.generateQrCode": "Сгенерировать QR-код",
  "process.continueSigning": "Продолжить подписание",
  "process.mobileOnlyWarning":
    "На телефоне доступно только подписание через eGov Mobile",
  "process.waitNcaLayerWarning":
    "Дождитесь завершения текущего подписания через NCALayer",
  "process.finishMobileSessionWarning":
    "Сначала завершите активную сессию eGov Mobile",
  "process.mobileSessionCheckError":
    "Не удалось проверить активную сессию подписания",
  "process.mobileSigningSuccess": "Документы подписаны через eGov Mobile",
  "process.manifestLoadError": "Не удалось получить NCAManifest для подписания",
  "process.ncaLayerConnectionError":
    "Не удалось подключиться к NCALayer. Убедитесь, что приложение запущено.",
  "process.signatureSaveError": "Не удалось сохранить подпись",

  // Подписание через eGov Mobile
  "mobileSign.title": "Подписание через eGov Mobile",
  "mobileSign.creating": "Создаём сессию подписания...",
  "mobileSign.retry": "Попробовать снова",
  "mobileSign.success": "Документы успешно подписаны через eGov Mobile.",
  "mobileSign.scanQr":
    "Отсканируйте QR-код в приложении eGov Mobile и подтвердите подписание.",
  "mobileSign.status": "Статус",
  "mobileSign.expiresAt": "Срок действия",
  "mobileSign.documents": "Документы",
  "mobileSign.openHint":
    "Нажмите «Открыть в eGov Mobile» и подтвердите подписание в приложении.",
  "mobileSign.open": "Открыть в eGov Mobile",
  "mobileSign.checking": "Проверяем...",
  "mobileSign.checkStatus": "Проверить статус",
  "mobileSign.newSession": "Создать новую сессию",
  "mobileSign.status.created": "Сессия создана",
  "mobileSign.status.waiting": "Ожидает подписи в eGov Mobile",
  "mobileSign.status.callback": "Подпись получена, выполняется проверка",
  "mobileSign.status.signed": "Документы подписаны",
  "mobileSign.status.failed": "Ошибка подписания",
  "mobileSign.status.expired": "Срок действия сессии истёк",
  "mobileSign.status.cancelled": "Подписание отменено",
  "mobileSign.cancelling": "Отменяем сессию eGov Mobile...",
  "mobileSign.cancelConfirm":
    "Отменить подписание через eGov Mobile? Текущая сессия будет завершена.",
  "mobileSign.cancelProcessing":
    "Подпись уже получена и обрабатывается. Дождитесь завершения операции.",
  "mobileSign.cancelError": "Не удалось отменить сессию eGov Mobile",
  "mobileSign.requestError": "Не удалось выполнить запрос eGov Mobile",

  // История и связанные документы
  "documentHistory.type": "Тип",
  "documentHistory.status": "Статус",
  "documentHistory.user": "Пользователь",
  "documentHistory.message": "Сообщение",
  "documentHistory.dateTime": "Дата и время",
  "linkedDocuments.name": "Наименование документа",
  "linkedDocuments.action": "Действие",

  // Layout / Sidebar
  "layout.logout": "Выход",
  "layout.createDocument": "Создать документ",
  "layout.myTasks": "Мои задания",
  "layout.allDocuments": "Все документы",
  "layout.allTasks": "Все задания",
  "layout.taskForRework": "На доработку",
  "layout.taskForSigning": "На подписание",
  "layout.taskForApproval": "На согласование",
  "layout.taskForReview": "На ознакомление",
  "layout.taskForExecution": "На исполнение",

  // Dashboard
  "dashboard.greeting.morning": "Доброе утро",
  "dashboard.greeting.afternoon": "Добрый день",
  "dashboard.greeting.evening": "Добрый вечер",
  "dashboard.retry": "Повторить",
  "dashboard.incomingDocuments": "Входящие документы",
  "dashboard.outgoingDocuments": "Исходящие документы",
  "dashboard.tasksToday": "Задачи на сегодня",
  "dashboard.overdueTasks": "Просроченные задачи",
  "dashboard.stats.total": "Всего документов",
  "dashboard.stats.inProgress": "Документы в работе",
  "dashboard.stats.signed": "Подписанных документов",
  "dashboard.stats.rework": "Документы на доработке",
  "dashboard.stats.denied": "Документы в отказе",
  "dashboard.chart.noData": "Нет данных",
  "dashboard.chart.total": "Всего",
  "dashboard.tasks.viewAll": "Смотреть все",
  "dashboard.tasks.empty": "Нет задач",
  "dashboard.tasks.initiator": "Инициатор:",
  "dashboard.tasks.deadline": "Срок:",
  "dashboard.tasks.viewDocument": "Перейти к просмотру",
  "dashboard.error.loadFailed": "Не удалось загрузить данные дашборда",
  "dashboard.error.generic": "Ошибка загрузки дашборда",
  "dashboard.emptyValue": "—",
  "dashboard.details.openList": "Открыть список",
  "dashboard.details.viewDocuments": "Посмотреть",
  "dashboard.details.totalFound": "Всего найдено",
  "dashboard.details.loading": "Загрузка списка",
  "dashboard.details.empty": "По выбранному показателю пока нет данных",
  "dashboard.details.error": "Не удалось загрузить список. Попробуйте ещё раз.",
  "dashboard.details.document": "Документ",
  "dashboard.details.categoryAndProcess": "Категория / процесс",
  "dashboard.details.status": "Статус",
  "dashboard.details.initiator": "Инициатор",
  "dashboard.details.dates": "Даты",
  "dashboard.details.actions": "Действия",
  "dashboard.details.createdAt": "Создан",
  "dashboard.details.openDocument": "Открыть документ",
  "dashboard.details.open": "Открыть",
  "dashboard.news.title": "Новости и полезные материалы",
  "dashboard.news.subtitle":
    "Обновления SmartDocs и важная информация об электронной подписи",
  "dashboard.news.readMore": "Подробнее",
  "dashboard.news.officialSource": "Официальный источник",
  "dashboard.news.sourceNotice":
    "Ссылка ведёт на сайт НУЦ РК и откроется в новой вкладке.",
  "dashboard.news.category.feature": "Возможности SmartDocs",
  "dashboard.news.category.guide": "Полезное",
  "dashboard.news.category.security": "Безопасность",
  "dashboard.news.egovMobile.title":
    "В SmartDocs доступно подписание через eGov Mobile",
  "dashboard.news.egovMobile.summary":
    "На этапе подписания выберите eGov Mobile: отсканируйте QR-код на компьютере или откройте приложение со смартфона. Загружать ключ ЭЦП на компьютер не требуется.",
  "dashboard.news.egovMobile.details.intro":
    "Функция доступна в заданиях, где требуется электронная подпись. SmartDocs передаёт пакет документа на подписание через eGov Mobile и автоматически фиксирует результат.",
  "dashboard.news.egovMobile.details.step1":
    "Откройте задание, в котором требуется подписание документа.",
  "dashboard.news.egovMobile.details.step2":
    "В поле «Способ подписания» выберите eGov Mobile.",
  "dashboard.news.egovMobile.details.step3":
    "На компьютере сгенерируйте QR-код и отсканируйте его в eGov Mobile. На смартфоне откройте приложение по предложенной ссылке.",
  "dashboard.news.egovMobile.details.step4":
    "Проверьте данные и подтвердите подписание в приложении. SmartDocs автоматически обновит статус задания.",
  "dashboard.news.expiration.title": "Проверьте срок действия ЭЦП заранее",
  "dashboard.news.expiration.summary":
    "Действующую ЭЦП можно перевыпустить онлайн. После окончания срока действия потребуется выпустить новый ключ.",
  "dashboard.news.expiration.details.intro":
    "Перевыпустить ЭЦП онлайн можно, пока текущий ключ ещё действует. Лучше проверить срок заранее, чтобы подписание документов оставалось доступным.",
  "dashboard.news.expiration.details.step1":
    "Проверьте срок действия ключей в личном кабинете НУЦ РК.",
  "dashboard.news.expiration.details.step2":
    "Запустите перевыпуск до окончания срока действия текущей ЭЦП.",
  "dashboard.news.expiration.details.step3":
    "Сохраните новые ключи на личном защищённом носителе и установите надёжный пароль.",
  "dashboard.news.expiration.details.step4":
    "Если срок уже истёк, необходимо выпустить новые ключи ЭЦП.",
  "dashboard.news.security.title": "Никому не передавайте свою ЭЦП",
  "dashboard.news.security.summary":
    "Храните ключ под полным контролем, используйте надёжный пароль и удаляйте ключи с общедоступных компьютеров.",
  "dashboard.news.security.details.intro":
    "ЭЦП имеет юридическую силу собственноручной подписи. Владелец должен самостоятельно контролировать ключи и доступ к ним.",
  "dashboard.news.security.details.rule1":
    "Храните ключи только на личном или защищённом носителе.",
  "dashboard.news.security.details.rule2":
    "Используйте уникальный надёжный пароль и не сохраняйте его рядом с ключом.",
  "dashboard.news.security.details.rule3":
    "Не отправляйте ключи и пароль через почту, мессенджеры или сторонние сайты.",
  "dashboard.news.security.details.rule4":
    "Удаляйте ключи с общедоступных компьютеров и перевыпускайте их при подозрении на компрометацию.",

  // Auth / Login
  "auth.welcomeFull":
      "Добро пожаловать в систему электронного документооборота",
  "auth.loginWithEcp": "Войти с помощью ЭЦП",
  "auth.or": "или",
  "auth.loginWith": "Войти с помощью",
  "auth.loginAndPassword": "логина и пароля",
  "auth.welcomeShort": "Добро пожаловать!",
  "auth.loginPlaceholder": "Логин",
  "auth.passwordPlaceholder": "Пароль",
  "auth.showPassword": "Показать пароль",
  "auth.hidePassword": "Скрыть пароль",
  "auth.loginButton": "Войти",
  "auth.ecp": "ЭЦП",
  "auth.ncaError":
      "Ошибка при подключении к NCALayer. Запустите NCALayer и нажмите ОК",
  "auth.chooseAccount": "Выберите рабочий аккаунт",
  "auth.useAnotherAccount": "Войти с другим аккаунтом",
  "auth.changeAccount": "Сменить аккаунт",
  "auth.removeAccount": "Удалить сохранённый аккаунт",
  "auth.rememberAccountTitle": "Запомнить аккаунт на этом устройстве?",
  "auth.rememberAccountDescription":
    "При следующем входе вы сможете выбрать этот аккаунт и ввести пароль или использовать ЭЦП.",
  "auth.rememberAccount": "Запомнить",
  "auth.notNow": "Не сейчас",
  "auth.accountMismatch":
    "Выбранный аккаунт не соответствует данным авторизации. Войдите повторно.",
  "auth.platformAdministrator": "Администратор платформы",

  // Document list / items
  "document.regNumber": "Рег. номер",
  "document.category": "Категория документа",
  "document.createdBy": "Создан",
  "document.status": "Статус документа",

  // Process history
  "processHistory.toggleHide": "Скрыть",
  "processHistory.toggleShow": "Показать",
  "processHistory.reworkSuffix": "процессы доработки",
  "processHistory.column.process": "Процесс",
  "processHistory.column.status": "Статус",
  "processHistory.column.executor": "Исполнитель",
  "processHistory.column.comment": "Комментарий",
  "processHistory.column.deadline": "Срок выполнения",
  "processHistory.column.start": "Начало выполнения",
  "processHistory.column.end": "Конец выполнения",
  "processHistory.initiator": "Инициатор:",
  "processHistory.signInfo": "Информация о подписи",
  "processHistory.executedBy": "исполнено",

  // Document details
  "document.edit": "Редактировать",
  "documentDraftBatch.title": "Массовое редактирование черновиков",
  "documentDraftBatch.select": "Выбрать черновик",
  "documentDraftBatch.open": "Редактировать выбранные",
  "documentDraftBatch.mapping": "Сопоставление файлов с шаблонами",
  "documentDraftBatch.values": "Параметры шаблонов",
  "documentDraftBatch.commonValue": "Общее значение",
  "documentDraftBatch.individualValues": "Индивидуальные значения",
  "documentDraftBatch.preview": "Предпросмотр и правка",
  "documentDraftBatch.apply": "Обновить черновики",
  "documentDraftBatch.noEditable":
    "Выберите неотправленные документы со статусом «Новый» или «На доработке».",
  "documentDraftBatch.legacyWarning":
    "Для старых файлов исходные параметры не сохранены. Выберите исходные шаблоны и проверьте предпросмотр перед обновлением.",
  "documentDraftBatch.success": "Черновики успешно обновлены",
  "document.send": "Отправить",
  "document.return": "Вернуть",
  "document.delete": "Удалить",
  "document.generateArchive": "Сгенерировать архив",
  "document.downloadArchive": "Скачать архив",
  "document.downloadElectronicCopies": "Скачать электронные копии",
  "document.tab.requisites": "Реквизиты документа",
  "document.tab.esedo": "ESEDO details",
  "document.tab.content": "Содержимое",
  "document.tab.attachments": "Прикрепленные документы",
  "document.tab.processes": "Процессы",
  "document.tab.history": "История",
  "document.tab.accessRights": "Права доступа",
  "document.tab.linkedDocuments": "Связанные документы",

  //navbar
  "navbar.home": "Главная",
  "navbar.users": "Пользователи",
  "navbar.companies": "Компании",
  "navbar.templates": "Шаблоны",
  "navbar.categories": "Категории",
  "navbar.entityApproval": "Координирование",
  "navbar.structures": "Структура документов",
  "navbar.nomenclatures": "Номенклатуры",
  "navbar.positions": "Должности",
  "navbar.processes": "Процессы",
  "navbar.roles": "Роли",
  "navbar.tenantManagement": "Компании платформы",
  "theme.dark": "Включить тёмную тему",
  "theme.light": "Включить светлую тему",
  "permission.uiDarkTheme": "Использование тёмной темы",
  "rolePermissions.appearance": "Оформление интерфейса",
  "navbar.logs": "Логи",
  "navbar.helpdesk": "Helpdesk",
  "navbar.myTickets": "Мои обращения",
  "navbar.newHelpdeskTickets": "Новые неназначенные обращения",
  "navbar.control": "Контрольная панель",
  "layout.sections": "Разделы",
  "layout.collapseSidebar": "Свернуть меню",
  "layout.expandSidebar": "Развернуть меню",
  "layout.closeSections": "Закрыть меню разделов",
  "navbar.documents": "Мои документы",
  "navbar.tasks": "Мои задания",
  "navbar.reports": "\u041e\u0442\u0447\u0435\u0442\u044b",
  "navbar.tracked":
    "\u041e\u0442\u0441\u043b\u0435\u0436\u0438\u0432\u0430\u0435\u043c\u043e\u0435",
  "navbar.favorite": "\u0418\u0437\u0431\u0440\u0430\u043d\u043d\u043e\u0435",
  "navbar.drafts": "\u0427\u0435\u0440\u043d\u043e\u0432\u0438\u043a\u0438",
  "navbar.rework":
    "\u041d\u0430 \u0434\u043e\u0440\u0430\u0431\u043e\u0442\u043a\u0435",

  // Document template form
  "docTemplate.titleEdit": "Редактировать шаблон",
  "docTemplate.titleCreate": "Создание шаблона",
  "docTemplate.name": "Название",
  "docTemplate.comment": "Комментарий",
  "docTemplate.status": "Статус",
  "docTemplate.template": "Шаблон",
  "docTemplate.footer.enabled": "Добавить нижний колонтитул",
  "docTemplate.footer.lastPage": "Только на последней странице",
  "docTemplate.footer.allPages": "На каждой странице",
  "docTemplate.footer.height": "Высота области, мм",
  "docTemplate.footer.heightError": "Укажите высоту от 10 до 80 мм",
  "docTemplate.footer.html": "HTML нижнего колонтитула",
  "docTemplate.footer.htmlError": "Заполните HTML нижнего колонтитула",
  "docTemplate.update": "Обновить",
  "docTemplate.create": "Создать",
  "docTemplate.details.content": "Содержимое шаблона",
  "docTemplate.details.options": "Значения",
  "docTemplate.details.pdfError": "Не удалось сформировать PDF",

  // Document template (payload/details)
  "documentTemplate.comment": "Комментарий",
  "documentTemplate.template": "Шаблон",

  // Document form
  "docForm.titleEdit": "Редактировать документ",
  "docForm.titleCreate": "Создание документа",
  "docForm.category": "Категория",
  "docForm.selectCategory": "Выбрать категорию",
  "docForm.params": "Параметры",
  "docForm.extraOptions": "Дополнительные настройки",
  "docForm.theme": "Тема",
  "docForm.nomenclature": "Номенклатура",
  "docForm.selectNomenclature": "Выбрать номенаклатуру",
  "docForm.price": "Ценности",
  "docForm.description": "Описание",
  "docForm.uploadDocument": "Загрузить документ",
  "docForm.selectTemplate": "Выбрать шаблон",
  "docForm.uploadTab": "Загрузить",
  "docForm.generateTab": "Сгенерировать",
  "docForm.previewTemplate": "Предпросмотр шаблона",
  "docForm.previewFilledTemplate": "Предпросмотр с полями",
  "docForm.previewFilledTitle": "Предпросмотр заполненного шаблона",
  "docForm.backToFields": "Вернуться к заполнению",
  "docForm.previewConflictTitle": "Поля шаблона изменены",
  "docForm.previewConflictMessage":
    "Значения полей были изменены. Обновить документ из шаблона? Ручные изменения в тексте будут потеряны.",
  "docForm.previewConflictHint":
    "Если оставить текущую редакцию, новые значения полей не попадут в документ.",
  "docForm.previewConflictKeep": "Оставить мою редакцию",
  "docForm.previewConflictRebuild": "Обновить из шаблона",
  "docForm.editedBadge": "Отредактировано",
  "docForm.editedDetailsTitle": "Изменения в файле",
  "docForm.changedFields": "Изменённые поля",
  "docForm.manualTextChanged": "Текст документа изменён вручную",
  "docForm.emptyValue": "Не заполнено",
  "docForm.leaveTitle": "Покинуть создание документа?",
  "docForm.leaveMessage":
    "Вы точно хотите перейти на другую страницу? Перед переходом рекомендуем завершить создание документа, иначе прогресс будет утерян.",
  "docForm.leaveStay": "Остаться",
  "docForm.leaveConfirm": "Перейти",
  "docForm.updateTemplate": "Обновить",
  "docForm.hideTemplate": "Скрыть",
  "docForm.mainFileSelectTemplate": "Выбрать шаблон",
  "docForm.fileName": "Название файла",
  "docForm.confirm": "Подтвердить",
  "docForm.delete": "Удалить",
  "docForm.mainFile": "Основной файл",
  "docForm.extraFiles": "Дополнительные файлы",
  "docForm.processList": "Список процессов",
  "docForm.deadline": "Срок",
  "docForm.apply": "Применить",
  "docForm.cancel": "Отменить",
  "docForm.datePlaceholder": "дд/мм/гггг",
  "docForm.executionType": "Тип исполнения",
  "docForm.serialExecution": "Последовaтельное исполнение",
  "docForm.parallelExecution": "Параллельное исполнение",
  "docForm.process": "Процесс",
  "docForm.addFreeProcess": "+ Добавить процесс",
  "docForm.freeProcessHint":
    "Можно добавить неограниченное количество свободных процессов из тех, что разрешены в категории.",
  "docForm.executorCanDeny": "Исполнитель может отказать",
  "docForm.selectProcessType": "Выберите тип процесса",
  "docForm.removeProcess": "Удалить процесс",
  "docForm.moveUp": "Выше",
  "docForm.moveDown": "Ниже",
  "docForm.name": "Наименование",
  "docForm.processKind": "Вид процесса",
  "docForm.processType": "Тип процесса",
  "docForm.receivers": "Получатели",
  "docForm.comment": "Комментарий",
  "docForm.submitUpdate": "Обновить",
  "docForm.submitCreate": "Создать",
  "docForm.fileNameRequired": "Необходимо заполнить название файла!",
  "docForm.templateRequired": "Необходимо выбрать шаблон!",
  "docForm.fieldRequired": "Поле обязательно для заполнения",
  "docForm.generateAdditionalFile": "Сгенерировать дополнительный файл",

  // Sign info modal
  "signInfo.title": "Информация о подписи",
  "signInfo.file": "Файл",
  "signInfo.bin": "БИН",
  "signInfo.iin": "ИИН",
  "signInfo.type": "Тип",
  "signInfo.serialNumber": "Серийный номер сертификата",
  "signInfo.signDate": "Дата подписания",
  "signInfo.fullName": "ФИО",
  "signInfo.certPeriod": "Срок Действия Сертификата",

  // Info list
  "infoList.category": "Категория",
  "infoList.initiator": "Инициатор",
  "infoList.theme": "Тема",
  "infoList.index": "Индекс документа",
  "infoList.createdAt": "Дата создания",
  "infoList.status": "Статус",

  // Profile
  "profile.title": "Личный кабинет",
  "profile.upload": "+ Загрузить",
  "profile.changePhoto": "Изменить фото",
  "profile.uploadPhoto": "Загрузить фото",
  "profile.transferRights": "Передача прав",
  "profile.changePassword": "Сменить пароль",
  "profile.changePasswordTitle": "Смена пароля",
  "profile.refreshRole": "Обновить роль",
  "profile.refreshRoleLoading": "Обновление...",
  "profile.refreshRoleSuccess": "Роль и права успешно обновлены",
  "profile.refreshRoleError": "Не удалось обновить роль и права",
  "profile.switchAccount": "Сменить рабочий аккаунт",
  "profile.login": "Логин",
  "profile.email": "Электронная почта",
  "profile.iin": "ИИН",
  "profile.name": "Имя",
  "profile.surname": "Фамилия",
  "profile.middleName": "Отчество",
  "profile.company": "Компания",
  "profile.department": "Структурное подразделение",
  "profile.job": "Должность",
  "profile.manager": "Руководитель",
  "profile.password": "Пароль",
  "profile.save": "Сохранить",
  "profile.updateSuccess": "Данные успешно обновлены",
  "profile.updateError": "Ошибка обновления данных",

  // Process template list
  "processTemplateList.title": "Список процессов",
  "processTemplateList.name": "Имя",
  "processTemplateList.search": "Поиск",
  "processTemplateList.create": "Создать",
  "processTemplateList.noData": "Ничего не найдено",
  "processTemplateList.column.id": "ID",
  "processTemplateList.column.name": "Название",
  "processTemplateList.column.actionName": "Наименование действия",
  "processTemplateList.column.type": "Тип",
  "processTemplateList.column.position": "Позиция",
  "processTemplateList.action.edit": "Редактировать",
  "processTemplateList.type.active": "Активный",
  "processTemplateList.type.disabled": "Отключено",
  "processTemplateList.type.system": "Системный",
  "processTemplateList.system.name.approval": "На согласование",
  "processTemplateList.system.name.signing": "На подписание",
  "processTemplateList.system.name.rework": "На доработку",
  "processTemplateList.system.action.approval": "Согласовать",
  "processTemplateList.system.action.signing": "Подписать",
  "processTemplateList.system.action.rework": "Доработать",

  // Job form
  "jobForm.titleEdit": "Редактирование должности",
  "jobForm.titleCreate": "Создание должности",
  "jobForm.name": "Название",
  "jobForm.status": "Статус",
  "jobForm.namePlaceholder": "Название",
  "jobForm.submitUpdate": "Обновить должность",
  "jobForm.submitCreate": "Создать должность",

  // Nomenclature form
  "nomenclatureForm.titleEdit": "Редактирование номенклатуры",
  "nomenclatureForm.titleCreate": "Создание номенклатуры",
  "nomenclatureForm.name": "Название",
  "nomenclatureForm.index": "Индекс",
  "nomenclatureForm.status": "Статус",
  "nomenclatureForm.namePlaceholder": "Название",
  "nomenclatureForm.submitUpdate": "Обновить номенклатуру",
  "nomenclatureForm.submitCreate": "Создать номенклатуру",

  // Company list / form
  "company.title": "Список компаний",
  "company.create": "Создать",
  "company.section.board": "Правление",
  "company.name": "Название",
  "company.namePlaceholder": "Название",
  "company.indexPlaceholder": "Индекс",
  "company.parent": "Родительская компания",
  "company.index": "Индекс",
  "company.status": "Статус",
  "company.isCompany": "Является компанией",
  "company.bin": "БИН",
  "company.rootBinPlatformOnly":
    "БИН корневой компании изменяет администратор платформы.",
  "company.binPlaceholder": "БИН",
  "company.type": "Тип",
  "company.submitUpdate": "Редактировать компанию",
  "company.submitCreate": "Создать компанию",
  "company.titleEdit": "Редактировать компанию",
  "company.titleCreate": "Создание компании",
  "company.filter.label": "Доступ компании",
  "company.filter.all": "Все компании",
  "company.filter.internal": "Только внутренние",
  "company.filter.external": "Только внешние",
  "company.accessMode": "Режим доступа",
  "company.empty.title": "Выберите компанию",
  "company.empty.description":
    "Выберите компанию из списка, чтобы посмотреть или изменить её данные.",
  "company.empty.createHint":
    "Чтобы добавить компанию, нажмите кнопку «Создать компанию».",
  "company.loading": "Загрузка компании...",
  "company.loadError": "Не удалось загрузить компанию",
  "company.parentLoadError":
    "Не удалось загрузить список родительских компаний",

  // Common UI
  "common.allJobs": "Все должности",
  "common.allRoles": "Все роли",
  "common.allStatuses": "Все статусы",
  "common.allCategories": "Все категории",
  "common.allReportTypes": "Все типы отчётов",
  "common.noData": "Ничего не найдено",
  "common.fullName": "Полное имя",
  "common.confirm": "Подтвердить",
  "common.cancel": "Отмена",
  "common.clear": "Очистить",
  "common.details": "Подробнее",
  "common.edit": "Редактировать",
  "common.notSelected": "Не выбрано",
  "common.companies": "Компании",
  "common.search": "Поиск",
  "common.create": "Создать",
  "common.name": "Имя",
  "common.surname": "Фамилия",
  "common.status": "Статус",
  "common.iin": "ИИН",
  "common.job": "Должность",
  "common.role": "Роль",
  "common.company": "Компания",
  "common.title": "Название",
  "common.placeholderName": "Название",
  "common.index": "Индекс",
  "common.type": "Тип",
  "common.id": "ID",
  "common.save": "Сохранить",

  // User
  "userList.title": "Список пользователей",
  "userForm.titleEdit": "Редактирование",
  "userForm.titleCreate": "Создание",
  "userForm.user": "пользователя",
  "userForm.iinError": "Введите корректный ИИН",
  "userForm.userStatus": "Статус пользователя:",
  "userForm.save": "Сохранить",
  "userDetails.title": "Информация о пользователе",
  "userDetails.delete": "Удалить",

  // Transfer authority
  "transferAuthority.title": "Список переданных прав",
  "transferAuthority.menuTitle": "Замещение",
  "transferAuthority.rightsType": "Тип прав",
  "transferAuthority.create": "+ Создать",
  "transferAuthority.reason": "Причина",
  "transferAuthority.transferReason": "Причина передачи",
  "transferAuthority.closeReason": "Причина закрытия",
  "transferAuthority.startDate": "Дата начала",
  "transferAuthority.endDate": "Дата окончания",
  "transferAuthority.transferredRights": "Переданные права",
  "transferAuthority.receivedRights": "Полученные права",
  "transferAuthority.full": "Полный",
  "transferAuthority.partial": "Частичный",
  "transferAuthority.closed": "Закрыто",
  "transferAuthority.waiting": "Ожидание",
  "transferAuthority.active": "Активно",
  "transferAuthority.denied": "Отказано",
  "transferAuthority.createModalTitle": "Создать передачу прав",
  "transferAuthority.selectUser": "Выбрать пользователя",
  "transferAuthority.startDateLabel": "Дата начала",
  "transferAuthority.endDateLabel": "Дата окончания",
  "transferAuthority.invalidDate": "Неправильная дата",
  "transferAuthority.createSuccess": "Заявка на передачу прав создана",
  "transferAuthority.createError": "Не удалось создать передачу прав",
  "transferAuthority.loadError": "Не удалось загрузить список передач прав",
  "transferAuthority.confirmSuccess": "Передача прав подтверждена",
  "transferAuthority.confirmError": "Не удалось подтвердить передачу прав",
  "transferAuthority.denySuccess": "Передача прав отклонена",
  "transferAuthority.denyError": "Не удалось отклонить передачу прав",

  "profile.entityApproval": "Координирование",

  // Entity approval
  "entityApproval.title": "Очередь согласования",
  "entityApproval.entityType": "Тип сущности",
  "entityApproval.actionType": "Действие",
  "entityApproval.entityId": "ID сущности",
  "entityApproval.requesterId": "Инициатор (ID)",
  "entityApproval.requester": "Автор",
  "entityApproval.coordinatorId": "Координатор",
  "entityApproval.payload": "Данные заявки",
  "entityApproval.payloadCategory": "Категория документа",
  "entityApproval.approvalStatus": "Статус согласования",
  "entityApproval.constructor.mainInfo": "Основная информация",
  "entityApproval.template.mainInfo": "Основная информация",
  "entityApproval.user.mainInfo": "Основная информация",
  "entityApproval.user.security": "Безопасность",
  "entityApproval.company.mainInfo": "Основная информация",
  "entityApproval.approve": "Одобрить",
  "entityApproval.reject": "Отклонить",
  "entityApproval.detailsTitle": "Заявка на согласование",
  "entityApproval.requestInfo": "Информация о заявке",
  "entityApproval.rejectTitle": "Отклонение заявки",
  "entityApproval.rejectReason": "Причина отклонения",
  "entityApproval.approveSuccess": "Заявка одобрена",
  "entityApproval.approveError": "Не удалось одобрить заявку",
  "entityApproval.rejectSuccess": "Заявка отклонена",
  "entityApproval.rejectError": "Не удалось отклонить заявку",
  "entityApproval.backToList": "К списку согласований",
  "entityApproval.loading": "Загрузка заявки на согласование...",
  "entityApproval.loadError": "Не удалось загрузить заявку на согласование",
  "entityApproval.type.documentConstructor": "Категория документа",
  "entityApproval.type.documentTemplate": "Шаблон документа",
  "entityApproval.type.company": "Компания",
  "entityApproval.type.user": "Пользователь",
  "entityApproval.action.create": "Создание",
  "entityApproval.action.update": "Изменение",
  "entityApproval.action.deactivate": "Деактивация",
  "entityApproval.status.waiting":
    "\u041d\u0435 \u0441\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u043e",
  "entityApproval.status.approved": "Согласовано",
  "entityApproval.status.rejected":
    "\u041e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u043e",
  "entityApproval.entityStatus.waiting": "На согласовании",
  "entityApproval.entityStatus.active": "Активно",
  "entityApproval.entityStatus.deactivated": "Деактивировано",

  // Deactivate entity
  "deactivate.title": "Деактивация",
  "deactivate.confirm": "Будет создана заявка на деактивацию. Продолжить?",
  "deactivate.coordinator": "Координатор (необязательно)",
  "deactivate.coordinatorNotSet": "Не назначать",
  "deactivate.submit": "Отправить на согласование",
  "deactivate.success": "Заявка на деактивацию отправлена",
  "deactivate.error": "Не удалось отправить заявку",
  "approval.submitted": "Заявка отправлена на согласование",
  "approval.submitError": "Не удалось отправить заявку на согласование",
  "approval.pending": "На согласовании",
  "approval.viewRequest": "Открыть заявку",

  "esedo.title": "ЕСЭДО",
  "esedo.enabled": "Включить атрибуты ЕСЭДО",
  "esedo.documentType": "Тип документа ЕСЭДО",
  "esedo.questionNature": "Характер вопроса",
  "esedo.counterpartyMode": "Режим выбора контрагентов",
  "esedo.modeNotUsed": "Не используется",
  "esedo.modeOptional": "Необязательно",
  "esedo.modeRequired": "Обязательно",
  "esedo.partners": "Контрагенты ЕСЭДО",
  "esedo.selectPartners": "Выберите контрагентов",
  "esedo.partnersRequired":
    "Необходимо выбрать хотя бы одного контрагента ЕСЭДО",

  "entityScope.title": "Область видимости и согласование",
  "entityScope.hint":
      "Изменения применятся после одобрения координатором. Директорат определяется автоматически.",
  "entityScope.viewScope": "Кто видит",
  "entityScope.editScope": "Кто может изменять",
  "entityScope.viewDirectorates": "Директораты просмотра",
  "entityScope.editDirectorates": "Директораты редактирования",
  "entityScope.directorate": "Директорат",
  "entityScope.selectDirectorates": "Выберите директораты",
  "entityScope.coordinator": "Координатор согласования",
  "entityScope.coordinatorAny": "Любой координатор директората",
  "entityScope.coordinatorHint":
      "Если не выбран — заявку может обработать любой координатор вашего директората",
  "entityScope.private": "Только создатель",
  "entityScope.unit": "Директорат",
  "entityScope.multiUnit": "Несколько директоратов",
  "entityScope.all": "Все",

  "company.authEnabled": "Доступ к внутреннему контуру (SaaS)",
  "company.externalSigning": "Внешний контрагент (только подписание)",
  "userForm.userType": "Тип пользователя",
  "userForm.userTypeInternal": "Внутренний",
  "userForm.userTypeExternal": "Внешний",

  // Role
  "roleList.title": "Список ролей",
  "roleForm.role": "роли",
  "roleForm.systemConfig": "Системная конфигурация",
  "roleForm.viewLogs": "Просмотр логов",
  "roleForm.documentConfig": "Конфигурация документов",
  "roleForm.viewDocument": "Просмотр документа",
  "roleForm.editRole": "Редактировать роль",
  "roleForm.createRole": "Создать роль",
  "roleForm.nomenclature": "Номенклатура",
  "roleForm.processes": "Процессы",
  "roleForm.constructor": "Конструктор",
  "roleForm.template": "Шаблон",
  "roleForm.user": "Пользователь",
  "roleForm.permissions": "Доступы",
  "roleDetails.title": "Информация о роли",
  "roleDetails.userCount": "Количество пользователей",
  "permission.helpdeskManage": "Управление обращениями Helpdesk",

  // Logs
  "logs.title": "Логи",
  "logs.dateFrom": "Дата от",
  "logs.dateTo": "Дата до",
  "logs.apply": "Применить",
  "logs.cancel": "Отменить",
  "logs.datePlaceholder": "дд/мм/гггг",
  "logs.user": "Пользователь",
  "logs.userPublicId": "Публичный ID пользователя",
  "logs.url": "Адрес",
  "logs.message": "Сообщение",
  "logs.createdAt": "Дата создания",
  "logs.pageSize": "Строк на странице",
  "logs.export": "Выгрузить таблицу",
  "logs.exportError": "Не удалось выгрузить логи",
  "logs.status.success": "Выполнен",
  "logs.status.error": "Ошибка",

  // Job
  "jobList.title": "Список должностей",
  "jobDetails.title": "Информация о должности",

  // Process users / documents
  "processUsersList.searchByDocName": "Поиск по названию документа",
  "processUsersList.documentCategory": "Категория документа",
  "processUsersList.documentNumber": "Номер документа",
  "processUsersList.documentCreator": "Создатель документа",
  "processUsersList.extendedFilters": "Расширенные фильтры",
  "processUsersList.themePlaceholder": "Тема",
  "processUsersList.myProcesses": "Мои процессы",
  "processUsersList.createdFrom": "Дата создания от",
  "processUsersList.createdTo": "Дата создания до",
  "processTemplateForm.titleEdit": "Редактирование процесса",
  "processTemplateForm.titleCreate": "Создание процесса",
  "processTemplateForm.processName": "Наименование процесса",
  "processTemplateForm.actionName": "Наименование действия",
  "processTemplateForm.position": "Позиция",
  "processTemplateForm.language.ru": "Русский язык",
  "processTemplateForm.language.en": "Английский язык",
  "processTemplateForm.language.kz": "Казахский язык",
  "processTable.process": "Процесс",
  "processTable.deadline": "Срок выполнения",
  "processTable.start": "Начало выполнения",
  "processTable.end": "Конец выполнения",

  // Nomenclature
  "nomenclatureList.title": "Список номенклатуры",
  "nomenclatureList.upload": "Загрузить",
  "nomenclatureList.ordNumber": "Пор. номер",
  "nomenclatureList.indOrdNumber": "Пром. пор. номер",
  "nomenclatureDetails.title": "Информация о номенклатуре",
  "nomenclatureForm.submitUpdateShort": "Обновить",
  "nomenclatureForm.submitCreateShort": "Создать",

  // Document template
  "docTemplateList.title": "Список шаблонов",

  // Document constructor
  "docConstructorList.title": "Список категорий",
  "docConstructorList.description": "Описание",
  "docConstructorList.processCount": "Процессы",
  "docConstructorList.access": "Доступ (просмотр / изменение)",
  "docConstructorList.lastUpdated": "Последнее изменение",
  "docConstructorView.title": "Просмотр категории",
  "docConstructorView.loading": "Загрузка…",
  "docConstructorView.backToList": "К списку категорий",
  "docConstructorView.categoryId": "ID категории",
  "docConstructorView.approvalStatus": "Статус согласования",
  "docConstructorView.processCount": "Количество процессов",
  "docConstructorView.deadlineDays": "Срок, дней",
  "docConstructorView.parallelExecution": "Параллельное исполнение",
  "docConstructorView.allowedTemplates": "ID разрешённых шаблонов процессов",
  "docConstructorView.templateId": "Шаблон процесса",
  "docConstructorView.price": "Сумма",
  "docConstructorForm.titleEdit": "Редактировать категорию",
  "docConstructorForm.titleCreate": "Создание категории",
  "docConstructorForm.name": "Название",
  "docConstructorForm.subject": "Тема",
  "docConstructorForm.nomenclature": "Номенклатура",
  "docConstructorForm.description": "Описание",
  "docConstructorForm.descriptionPlaceholder": "Описание",
  "docConstructorForm.active": "Активно",
  "docConstructorForm.disable": "Отключено",
  "docConstructorForm.params": "Параметры",
  "docConstructorForm.paramDescription": "Описание",
  "docConstructorForm.paramPrice": "Ценность",
  "docConstructorForm.filled": "Заполнен",
  "docConstructorForm.mainFile": "Основной файл",
  "docConstructorForm.extraFiles": "Дополнительные файлы",
  "docConstructorForm.process": "Процесс",
  "docConstructorForm.processPlaceholder": "Выберите процесс",
  "docConstructorForm.processRequired": "Выберите процесс для каждого этапа",
  "docConstructorForm.freeProcess": "Свободный процесс при создании документа",
  "docConstructorForm.freeProcessHint":
    "Исполнители, порядок и конкретный тип процесса для свободного шага задаются при создании документа.",
  "docConstructorForm.processKind": "Вид процесса",
  "docConstructorForm.processKindTemplate": "По шаблону",
  "docConstructorForm.processKindRequired": "Обязательный",
  "docConstructorForm.processKindFree": "Свободный",
  "docConstructorForm.stepTypes": "Разрешенные типы процесса",
  "docConstructorForm.processType": "Тип процесса",
  "docConstructorForm.processTypeApproval": "Согласование",
  "docConstructorForm.processTypeSigning": "Подписание",
  "docConstructorForm.processTypeReview": "Ознакомление",
  "docConstructorForm.processTypeExecution": "Исполнение",
  "docConstructorForm.filling": "Заполнение",
  "docConstructorForm.signEcp": "Подписать ЭЦП",
  "docConstructorForm.parallelExecution": "Разрешить параллельное исполнение",
  "docConstructorForm.receiverType": "Вид получателя",
  "docConstructorForm.receiverUser": "Пользователь",
  "docConstructorForm.receiverStructure": "Компания",
  "docConstructorForm.filterType": "Тип фильтра",
  "docConstructorForm.sameOrigin": "Отдел пользователя",
  "docConstructorForm.allCompanies": "Все компании",
  "docConstructorForm.individualCompany": "Индивидуальный выбор компании",
  "docConstructorForm.creatorCompany": "Компания инициатора",
  "docConstructorForm.departmentWithChildren": "Отдел с дочерними отделами",
  "docConstructorForm.companies": "Компании",
  "docConstructorForm.role": "Роль",
  "docConstructorForm.users": "Пользователи",
  "docConstructorForm.job": "Должности",
  "docConstructorForm.rework": "Доработка",
  "docConstructorForm.deny": "Отказать",
  "docConstructorForm.answer": "Ответить",
  "docConstructorForm.review": "Ознакомление",
  "docConstructorForm.transfer": "Передать",
  "docConstructorForm.filteringType": "Тип фильтрации",
  "docConstructorForm.addProcess": "+ Добавить процесс",
  "docConstructorForm.needProcesses": "Нужно добавить процессы",
  "docConstructorForm.receiverTypeRequired":
      "Вид получателя не может быть пустой",
  "docConstructorForm.update": "Обновить",
  "docConstructorForm.create": "Создать",

  // Document list
  "documentList.myDocuments": "Мои документы",
  "documentList.documentStatus": "Статус документа",
  "documentList.foundDocuments.one": "Найден {count} документ",
  "documentList.foundDocuments.few": "Найдено {count} документа",
  "documentList.foundDocuments.many": "Найдено {count} документов",

  "documentList.shownRange": "Показаны документы {from}–{to} из {total}",
  "documentList.noDocuments": "Документы не найдены",
  "pagination.navigation": "Навигация по страницам",
  "pagination.firstPage": "Первая страница",
  "pagination.previousPage": "Предыдущая страница",
  "pagination.page": "Страница",
  "pagination.nextPage": "Следующая страница",
  "pagination.lastPage": "Последняя страница",

  // Company
  "companyDetails.title": "Структура компании",
  "companyDetails.departments": "Отделы",
  "companyDetails.selectCompany": "Выберите компанию",
  "companyDetails.branchName": "Наименование филиала",
  "companyDetails.counteragentEsedo": "Контрагент ЭСЕДО",
  "companyDetails.index": "Индекс",
  "companyDetails.bin": "БИН",
  "companyDetails.position": "Позиция",
  "companyDetails.personType": "Тип лица",
  "companyDetails.personTypeLegal": "Юридическое лицо",
  "companyDetails.personTypeIndividual": "Физическое лицо",
  "companyDetails.isCompany": "Является компанией",
  "companyList.title": "Список компаний",
  "companyList.board": "Правление",

  // Reports
  "reports.title": "Отчеты",
  "reports.theme": "Тема",
  "reports.authorName": "Имя автора",
  "reports.regNumber": "Номер регистраций",
  "reports.dateEnd": "Дата конец",
  "reports.name": "Наименование",
  "reports.saveReport": "Сохранить отчет",
  "reports.save": "Сохранить",
  "reports.savedReports": "Сохраненные отчеты",
  "reports.reportFiles": "Файлы отчета",
  "reports.excelExport": "Экспорт в Excel",
  "reports.category": "Категория",
  "reports.nomenclature": "Номенклатура",
  "reports.description": "Описание",
  "reports.value": "Ценность",
  "reports.status": "Статус",
  "reports.documentReportTab": "Отчет документов",
  "reports.systemReportTab": "Системные отчеты",
  "reports.reportTypeFilter": "Тип отчета",
  "reports.documentCategory": "Категория документа",
  "reports.subCategory": "Подкатегория",
  "reports.createdAtStart": "Дата создания с",
  "reports.createdAtEnd": "Дата создания по",
  "reports.finishedAtStart": "Дата завершения с",
  "reports.finishedAtEnd": "Дата завершения по",
  "reports.typeCompletedOnTime": "Завершено в срок",
  "reports.typeOverdue": "Просрочено",
  "reports.typeInProgress": "В процессе / новые",
  "reports.typeRejected": "Отклонено",
  "reports.columnId": "ID",
  "reports.columnDocumentNumber": "Номер документа",
  "reports.columnCreatorFullName": "Инициатор",
  "reports.columnSubCategoryName": "Подкатегория",
  "reports.columnReceiversNames": "Контрагенты",
  "reports.columnSubdivisionName": "Подразделение",
  "reports.columnEsedoSenderName": "Отправитель ГО",
  "reports.columnIncomingNumber": "Входящий номер",
  "reports.columnOutgoingNumber": "Исходящий номер",
  "reports.columnExecutors": "Исполнитель",
  "reports.columnDeadline": "Срок",
  "reports.columnFinishedAt": "Дата завершения",
  "reports.saveTemplateTitle": "Сохранить шаблон",
  "reports.templateType": "Тип шаблона",
  "reports.exportSuccess": "Отчет успешно выгружен",
  "reports.exportError": "Не удалось выгрузить отчет",
  "reports.templateSaved": "Шаблон сохранен",
  "reports.templateDeleted": "Шаблон удален",
  "reports.deleteTemplateConfirm": "Вы точно хотите удалить?",
  "reports.systemReportType": "Тип системного отчета",
  "reports.timeType": "Тип периода",
  "reports.timeTypeCreated": "По дате создания",
  "reports.timeTypeFinished": "По дате завершения",
  "reports.companies": "Компании",
  "reports.processType": "Тип процесса",
  "reports.roles": "Роли пользователей",
  "reports.isSigning": "Подписание",
  "reports.sewsType": "Тип ESEDO",
  "reports.preview": "Предпросмотр",
  "reports.previewError": "Не удалось загрузить предпросмотр",
  "reports.previewFromTemplate": "Предпросмотр из шаблона",
  "reports.exportFromTemplate": "Экспорт из шаблона",

  "archive.title": "Структура документов",
  "archive.createDocument": "Создать документ",
  "archive.createFolder": "Создать папку",
  "archive.move": "Переместить",
  "archive.delete": "Удалить",
  "archive.root": "Корень",
  "archive.regNumber": "Номер дела",
  "archive.type": "Тип",
  "archive.date": "Дата",
  "archive.folder": "Папка",
  "archive.document": "Документ",
  "archive.open": "Открыть",
  "archive.folderAccess": "Доступ к папке",
  "archive.currentAccess": "Текущие доступы",
  "archive.grantAccess": "Выдать доступ пользователям",
  "archive.grantAccessSubmit": "Выдать доступ",
  "archive.moveHint": "Выберите папку назначения",
  "archive.moveTarget": "Назначение",
  "archive.noFolders": "Нет вложенных папок",
  "archive.downloadFolder": "Скачать папку",
  "archive.deleteFolderConfirm": "Удалить выбранную папку(и)?",
  "archive.deleteSuccess": "Успешно удалено",
  "archive.loading": "Загрузка...",

  "common.close": "Закрыть",
  "common.delete": "Удалить",
  "common.error": "Произошла ошибка",

  "sign.sign": "Подписать",
  "sign.rework": "Передать на доработку",
  "sign.deny": "Отказать",
  "sign.success": "Документ успешно подписан",
  "sign.denied": "Документ отклонен",
  "sign.reworked": "Отправлено на доработку",

  "sign.number": "№",
  "sign.description": "Описание",
  "sign.expiresAt": "Дата окончания",
  "sign.recipient": "Получатель",
  "sign.recipientIinBin": "БИН получателя",
  "sign.status": "Статус",
  "sign.deniedComment": "Причина отказа",

  "sign.tabs.documentDetails": "Реквизиты документа",
  "sign.tabs.attachedFiles": "Прикрепленные файлы",

  "sign.actions.downloadFile": "Скачать файл",
  "sign.actions.viewFile": "Просмотр файла",
  "sign.enter_comment": "Введите комментарий",

  "notification.title": "Список оповещений",
  "notification.markRead":
    "\u041e\u0442\u043c\u0435\u0442\u0438\u0442\u044c \u043f\u0440\u043e\u0447\u0438\u0442\u0430\u043d\u043d\u044b\u043c",
  "notification.selectAll":
    "\u0412\u044b\u0434\u0435\u043b\u0438\u0442\u044c \u0432\u0441\u0435",
  "profile.roles": "\u0420\u043e\u043b\u0438",
  "profile.permissions":
    "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u044f",
  "process.startedAt":
    "\u0414\u0430\u0442\u0430 \u043d\u0430\u0447\u0430\u043b\u0430 \u0438\u0441\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f",
  "process.finishedAt":
    "\u0414\u0430\u0442\u0430 \u043e\u043a\u043e\u043d\u0447\u0430\u043d\u0438\u044f \u0438\u0441\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f",
  "process.actualExecutor":
    "\u0424\u0430\u043a\u0442\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u0438\u0441\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c",
  "process.onBehalfOf":
    "\u0437\u0430\u043c\u0435\u0449\u0435\u043d\u0438\u0435",
  "common.noAccessToEdit":
    "\u0423 \u0432\u0430\u0441 \u043d\u0435\u0442 \u043f\u0440\u0430\u0432 \u043d\u0430 \u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u044d\u0442\u043e\u0433\u043e \u0440\u0430\u0437\u0434\u0435\u043b\u0430",
  "common.apply": "\u041f\u0440\u0438\u043c\u0435\u043d\u0438\u0442\u044c",
  "profile.roleDetails":
    "\u0418\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u043e \u0440\u043e\u043b\u0438",
  "roleForm.adGroup": "\u0413\u0440\u0443\u043f\u043f\u0430 \u0432 AD",
  "roleForm.adGroupPlaceholder":
    "\u041d\u0430\u043f\u0440\u0438\u043c\u0435\u0440, EDMS_COORDINATORS",
  "fileTable.owner": "\u0412\u043b\u0430\u0434\u0435\u043b\u0435\u0446",
  "fileTable.fileName":
    "\u041d\u0430\u0438\u043c\u0435\u043d\u043e\u0432\u0430\u043d\u0438\u0435 \u0444\u0430\u0439\u043b\u0430",
  "fileTable.content":
    "\u0421\u043e\u0434\u0435\u0440\u0436\u0430\u043d\u0438\u0435",
  "fileTable.description": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
  "fileTable.uploadedAt":
    "\u0414\u0430\u0442\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0438",
  "fileTable.file": "\u0424\u0430\u0439\u043b",
  "fileTable.downloadFile":
    "\u0421\u043a\u0430\u0447\u0430\u0442\u044c \u0444\u0430\u0439\u043b",
  "fileTable.showDocument":
    "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442",
  "documentAccess.grantCoEditor":
    "\u0412\u044b\u0434\u0430\u0442\u044c \u043f\u0440\u0430\u0432\u0430 \u0441\u043e\u0440\u0435\u0434\u0430\u043a\u0442\u043e\u0440\u0430",
  "permission.documentAccessCoEditorGrant":
    "\u0412\u044b\u0434\u0430\u0447\u0430 \u043f\u0440\u0430\u0432 \u0441\u043e\u0440\u0435\u0434\u0430\u043a\u0442\u043e\u0440\u0430",
  "fileTable.previewUnavailable":
    "\u041f\u0440\u0435\u0434\u043f\u0440\u043e\u0441\u043c\u043e\u0442\u0440 \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u0435\u043d",
  "pdfViewer.loading": "Загрузка документа...",
  "pdfViewer.loadError": "Не удалось открыть PDF-документ",
  "pdfViewer.unsupported": "Полученный файл не является PDF-документом",
  "pdfViewer.pageError": "Не удалось отобразить страницу",
  "pdfViewer.page": "Страница",
  "pdfViewer.of": "из",
  "pdfViewer.firstPage": "Первая страница",
  "pdfViewer.previousPage": "Предыдущая страница",
  "pdfViewer.nextPage": "Следующая страница",
  "pdfViewer.lastPage": "Последняя страница",
  "documentAccess.grantAccess":
    "\u0414\u0430\u0442\u044c \u0434\u043e\u0441\u0442\u0443\u043f",
  "documentAccess.user":
    "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c",
  "documentAccess.accessType":
    "\u0422\u0438\u043f \u043f\u0440\u0430\u0432\u0430",
  "documentAccess.action": "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
  "documentAccess.selectUser":
    "\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
  "documentAccess.view": "\u041f\u0440\u043e\u0441\u043c\u043e\u0442\u0440",
  "documentAccess.creator":
    "\u0421\u043e\u0437\u0434\u0430\u0442\u0435\u043b\u044c",
  "documentAccess.coEditor":
    "\u0421\u043e\u0440\u0435\u0434\u0430\u043a\u0442\u043e\u0440",
  "permission.entityApprovalCoordinate":
    "\u041a\u043e\u043e\u0440\u0434\u0438\u043d\u0430\u0442\u043e\u0440 \u0441\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u0438\u044f",
  "permission.documentConstructorCreate":
    "\u0421\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0439 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.documentConstructorEdit":
    "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0439 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.documentConstructorDeactivate":
    "\u0414\u0435\u0430\u043a\u0442\u0438\u0432\u0430\u0446\u0438\u044f \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0439 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.documentTemplateCreate":
    "\u0421\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u0448\u0430\u0431\u043b\u043e\u043d\u043e\u0432 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.documentTemplateEdit":
    "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u0448\u0430\u0431\u043b\u043e\u043d\u043e\u0432 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.documentTemplateDeactivate":
    "\u0414\u0435\u0430\u043a\u0442\u0438\u0432\u0430\u0446\u0438\u044f \u0448\u0430\u0431\u043b\u043e\u043d\u043e\u0432 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.documentBatchCreate":
    "\u041c\u0430\u0441\u0441\u043e\u0432\u043e\u0435 \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u043e\u0432",
  "permission.companyCreate":
    "\u0421\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439",
  "permission.companyEdit":
    "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439",
  "permission.companyDeactivate":
    "\u0414\u0435\u0430\u043a\u0442\u0438\u0432\u0430\u0446\u0438\u044f \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439",
  "permission.userCreate":
    "\u0421\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
  "permission.userEdit":
    "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
  "permission.userDeactivate":
    "\u0414\u0435\u0430\u043a\u0442\u0438\u0432\u0430\u0446\u0438\u044f \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
  "permission.userViewTenant":
    "\u041f\u0440\u043e\u0441\u043c\u043e\u0442\u0440 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439 \u0432\u0441\u0435\u0439 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
  "permission.userEditTenant":
    "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439 \u0432\u0441\u0435\u0439 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
  "permission.reportCreate":
    "\u0421\u043e\u0437\u0434\u0430\u043d\u0438\u0435 \u043e\u0442\u0447\u0435\u0442\u043e\u0432",
  "permission.reportEdit":
    "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u043e\u0442\u0447\u0435\u0442\u043e\u0432",
  "status.active": "\u0410\u043a\u0442\u0438\u0432\u043d\u043e",
  "status.disabled": "\u041e\u0442\u043a\u043b\u044e\u0447\u0435\u043d\u043e",
  "status.document.new": "\u041d\u043e\u0432\u044b\u0439",
  "status.document.process":
    "\u0412 \u043f\u0440\u043e\u0446\u0435\u0441\u0441\u0435",
  "status.document.rework":
    "\u041d\u0430 \u0434\u043e\u0440\u0430\u0431\u043e\u0442\u043a\u0435",
  "status.document.success": "\u0412\u044b\u043f\u043e\u043b\u043d\u0435\u043d",
  "status.document.denied": "\u041e\u0442\u043a\u0430\u0437\u0430\u043d",
  "status.document.deleted": "\u0423\u0434\u0430\u043b\u0435\u043d",
  "status.process.active": "\u0410\u043a\u0442\u0438\u0432\u043d\u044b\u0439",
  "status.process.wait":
    "\u0412 \u043e\u0436\u0438\u0434\u0430\u043d\u0438\u0438",
  "status.process.success": "\u0412\u044b\u043f\u043e\u043b\u043d\u0435\u043d",
  "status.process.denied": "\u041e\u0442\u043a\u0430\u0437\u0430\u043d",
  "status.process.cancelled": "\u041e\u0442\u043c\u0435\u043d\u0451\u043d",
  "docTemplate.manualFields.title":
    "\u041f\u043e\u043b\u044f \u0440\u0443\u0447\u043d\u043e\u0433\u043e \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f",
  "docTemplate.manualFields.subtitle":
    "\u0417\u043d\u0430\u0447\u0435\u043d\u0438\u044f, \u0432\u0432\u0435\u0434\u0435\u043d\u043d\u044b\u0435 \u043f\u0440\u0438 \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0430, \u0437\u0430\u043c\u0435\u043d\u044f\u0442 \u0441\u043e\u0432\u043f\u0430\u0434\u0430\u044e\u0449\u0438\u0435 \u0442\u0435\u0433\u0438 \u0432 \u0448\u0430\u0431\u043b\u043e\u043d\u0435.",
  "docTemplate.manualFields.addField":
    "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043f\u043e\u043b\u0435",
  "docTemplate.manualFields.fieldName":
    "\u041d\u0430\u0438\u043c\u0435\u043d\u043e\u0432\u0430\u043d\u0438\u0435 \u043f\u043e\u043b\u044f",
  "docTemplate.manualFields.tag":
    "\u0422\u0435\u0433 \u0432 \u0448\u0430\u0431\u043b\u043e\u043d\u0435",
  "docTemplate.manualFields.fieldType":
    "\u0422\u0438\u043f \u043f\u043e\u043b\u044f",
  "docTemplate.manualFields.required":
    "\u041e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e\u0435",
  "docTemplate.manualFields.delimiter":
    "\u0420\u0430\u0437\u0434\u0435\u043b\u0438\u0442\u0435\u043b\u044c",
  "docTemplate.manualFields.outputFormat":
    "\u0424\u043e\u0440\u043c\u0430\u0442 \u0432\u044b\u0432\u043e\u0434\u0430",
  "docTemplate.manualFields.options":
    "\u0412\u0430\u0440\u0438\u0430\u043d\u0442\u044b",
  "docTemplate.manualFields.addOption":
    "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0432\u0430\u0440\u0438\u0430\u043d\u0442",
  "docTemplate.manualFields.optionText": "\u0422\u0435\u043a\u0441\u0442",
  "docTemplate.manualFields.optionValue":
    "\u0417\u043d\u0430\u0447\u0435\u043d\u0438\u0435",
  "docTemplate.manualFields.sameAsText":
    "\u041a\u0430\u043a \u0442\u0435\u043a\u0441\u0442",
  "docTemplate.manualFields.removeOption":
    "\u0423\u0434\u0430\u043b\u0438\u0442\u044c",
  "docTemplate.manualFields.removeField":
    "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u043e\u043b\u0435",
  "docTemplate.manualFields.optionHint":
    "\u0415\u0441\u043b\u0438 \u0437\u043d\u0430\u0447\u0435\u043d\u0438\u0435 \u043f\u0443\u0441\u0442\u043e\u0435, \u0431\u0443\u0434\u0435\u0442 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d \u0442\u0435\u043a\u0441\u0442 \u0432\u0430\u0440\u0438\u0430\u043d\u0442\u0430.",
  "docTemplate.manualFieldType.textarea":
    "\u041c\u043d\u043e\u0433\u043e\u0441\u0442\u0440\u043e\u0447\u043d\u044b\u0439 \u0442\u0435\u043a\u0441\u0442",
  "docTemplate.manualFieldType.date": "\u0414\u0430\u0442\u0430",
  "docTemplate.manualFieldType.datetime":
    "\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043c\u044f",
  "docTemplate.manualFieldType.select":
    "\u0412\u044b\u0431\u043e\u0440 \u043e\u0434\u043d\u043e\u0433\u043e \u0437\u043d\u0430\u0447\u0435\u043d\u0438\u044f",
  "docTemplate.manualFieldType.multiSelect":
    "\u0412\u044b\u0431\u043e\u0440 \u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u0438\u0445 \u0437\u043d\u0430\u0447\u0435\u043d\u0438\u0439",
  "common.back": "Назад",
  "common.next": "Далее",
  "common.loading": "Загрузка...",
  "tenantManagement.title": "Управление компаниями",
  "tenantManagement.description":
    "Создание независимых компаний и их первых администраторов.",
  "tenantManagement.create": "Добавить компанию",
  "tenantManagement.editTitle": "Редактирование компании",
  "tenantManagement.companyName": "Название компании",
  "tenantManagement.bin": "БИН",
  "tenantManagement.adminSurname": "Фамилия администратора",
  "tenantManagement.adminName": "Имя администратора",
  "tenantManagement.adminMiddleName": "Отчество администратора",
  "tenantManagement.iin": "ИИН администратора",
  "tenantManagement.login": "Логин администратора",
  "tenantManagement.email": "Email администратора",
  "tenantManagement.password": "Первоначальный пароль",
  "tenantManagement.rootCompany": "Корневая организация",
  "tenantManagement.disable": "Заблокировать",
  "tenantManagement.disableConfirm":
    "Заблокировать компанию? Её пользователи потеряют доступ к системе.",
  "tenantManagement.activate": "Активировать",
  "tenantManagement.loadError": "Не удалось загрузить список компаний.",
  "tenantManagement.createSuccess": "Компания создана.",
  "tenantManagement.createError": "Не удалось создать компанию.",
  "tenantManagement.updateSuccess": "Реквизиты компании изменены.",
  "tenantManagement.updateError": "Не удалось изменить реквизиты компании.",
  "tenantManagement.statusSuccess": "Статус компании изменён.",
  "tenantManagement.statusError": "Не удалось изменить статус компании.",
  "tenantManagement.logo": "Логотип компании",
  "tenantManagement.logoHelp":
    "PNG, JPEG или WebP размером не более 1 МБ.",
  "tenantManagement.uploadLogo": "Загрузить логотип",
  "tenantManagement.deleteLogo": "Удалить логотип",
  "tenantManagement.deleteLogoConfirm": "Удалить логотип компании?",
  "tenantManagement.logoInvalid":
    "Выберите PNG, JPEG или WebP размером не более 1 МБ.",
  "tenantManagement.logoUpdated": "Логотип компании обновлён.",
  "tenantManagement.logoUpdateError": "Не удалось обновить логотип компании.",
  "tenantManagement.logoDeleted": "Логотип компании удалён.",
  "tenantManagement.logoDeleteError": "Не удалось удалить логотип компании.",
  "documentBatch.open": "Массовое создание",
  "documentBatch.title": "Массовое создание документов",
  "documentBatch.subtitle":
    "Создайте отдельный документ для каждого выбранного сотрудника и шаблона.",
  "documentBatch.step1": "Настройка",
  "documentBatch.step2": "Заполнение",
  "documentBatch.step3": "Проверка и создание",
  "documentBatch.name": "Название операции",
  "documentBatch.deadline": "Срок процесса",
  "documentBatch.category": "Категория",
  "documentBatch.nomenclature": "Номенклатура",
  "documentBatch.description": "Описание",
  "documentBatch.price": "Сумма",
  "documentBatch.processes": "Процессы",
  "documentBatch.processHint":
    "Для каждого процесса выберите, будет ли исполнителем текущий сотрудник или исполнители из настройки категории.",
  "documentBatch.freeProcesses": "Свободные процессы",
  "documentBatch.selectFreeProcesses": "Выберите типы процессов",
  "documentBatch.freeProcessesHint":
    "Выбранные процессы и тип исполнения будут одинаковыми для всех документов операции.",
  "documentBatch.requiredProcess": "Обязательный процесс",
  "documentBatch.selectedEmployee": "Выбранный сотрудник",
  "documentBatch.categoryExecutors": "Исполнители из настройки категории",
  "documentBatch.noProcesses": "В категории нет настроенных процессов.",
  "documentBatch.documentSource": "Источник документов",
  "documentBatch.templates": "Шаблоны",
  "documentBatch.selectTemplates": "Выберите один или несколько шаблонов",
  "documentBatch.templatesSelected": "Выбрано шаблонов: {count}",
  "documentBatch.mainTemplate": "Шаблон основного файла",
  "documentBatch.selectMainTemplate": "Выберите шаблон основного файла",
  "documentBatch.mainTemplateHint":
    "Основной файл определяет название и карточку создаваемого документа.",
  "documentBatch.additionalTemplates": "Шаблоны дополнительных файлов",
  "documentBatch.selectAdditionalTemplates":
    "Выберите один или несколько дополнительных шаблонов",
  "documentBatch.additionalTemplatesSelected":
    "Выбрано дополнительных шаблонов: {count}",
  "documentBatch.packageModeHint":
    "Для каждого сотрудника будет создан один документ с основным и дополнительными файлами.",
  "documentBatch.employees": "Сотрудники",
  "documentBatch.selectEmployees": "Выберите сотрудников",
  "documentBatch.employeesSelected": "Выбрано сотрудников: {count}",
  "documentBatch.sendImmediately":
    "Отправить документы в процесс сразу после создания",
  "documentBatch.sendImmediatelyHint":
    "Перед запуском система ещё раз проверит все данные. Если флажок снять, документы останутся черновиками.",
  "documentBatch.totalDocuments": "Будет создано документов",
  "documentBatch.totalFiles": "Будет создано файлов",
  "documentBatch.fieldScopes": "Общие и индивидуальные значения",
  "documentBatch.fieldScopesHint":
    "Общее значение вводится один раз. Индивидуальное значение можно изменить отдельно для каждого сотрудника.",
  "documentBatch.commonValue": "Общее значение",
  "documentBatch.individualValue": "Индивидуальное значение",
  "documentBatch.commonFields": "Общие поля",
  "documentBatch.individualFields": "Индивидуальные поля",
  "documentBatch.profileHint":
    "ФИО, ИИН и должность предварительно заполнены из профиля только для этой операции. Проверьте и при необходимости исправьте их.",
  "documentBatch.employee": "Сотрудник",
  "documentBatch.documentNames": "Названия документов",
  "documentBatch.documentNamesHint":
    "Доступны переменные {{template_name}}, {{full_name}} и {{iin}}.",
  "documentBatch.fileNames": "Названия документа и файлов",
  "documentBatch.fileNamesHint":
    "Название основного файла станет названием документа. Для дополнительных шаблонов задаются названия файлов. Доступны переменные {{template_name}}, {{full_name}} и {{iin}}.",
  "documentBatch.mainFile": "Основной файл",
  "documentBatch.additionalFile": "Дополнительный файл",
  "documentBatch.additionalFiles": "Дополнительные файлы",
  "documentBatch.uploadedFiles": "Загруженные файлы",
  "documentBatch.uploadedFilesHint":
    "Загруженные файлы будут добавлены в документ без изменений.",
  "documentBatch.fileUploadError": "Не удалось загрузить файл.",
  "documentBatch.previewDocuments": "Предпросмотр документов",
  "documentBatch.previewHint":
    "Выберите сотрудника и проверьте каждый шаблон с применёнными общими и индивидуальными значениями.",
  "documentBatch.previewEmployee": "Сотрудник для предпросмотра",
  "documentBatch.previewEmployeeRequired":
    "Выберите сотрудника для предпросмотра.",
  "documentBatch.review": "Проверка операции",
  "documentBatch.mode": "Режим",
  "documentBatch.creationFormat": "Формат создания",
  "documentBatch.packageFormat": "Один документ с дополнительными файлами",
  "documentBatch.separateFormat": "Отдельные документы",
  "documentBatch.sendMode": "Создать и отправить",
  "documentBatch.draftMode": "Создать черновики",
  "documentBatch.progress": "Ход создания",
  "documentBatch.successful": "Успешно",
  "documentBatch.failed": "С ошибкой",
  "documentBatch.retryFailed": "Повторить документы с ошибкой",
  "documentBatch.completed": "Все документы успешно созданы.",
  "documentBatch.create": "Создать документы",
  "documentBatch.toDocuments": "Перейти к документам",
  "documentBatch.defaultName": "Массовое создание",
  "documentBatch.loadError":
    "Не удалось загрузить данные для массового создания.",
  "documentBatch.categoryLoadError":
    "Не удалось загрузить настройку категории.",
  "documentBatch.usersLoadError": "Не удалось загрузить список сотрудников.",
  "documentBatch.requiredConfiguration":
    "Заполните название, категорию, номенклатуру и срок процесса.",
  "documentBatch.requiredSelections":
    "Выберите хотя бы одного сотрудника и один шаблон.",
  "documentBatch.documentSourceRequired":
    "Выберите хотя бы один шаблон или загрузите файл.",
  "documentBatch.mainSourceRequired":
    "Выберите шаблон основного файла или загрузите основной файл.",
  "documentBatch.additionalSourceRequired":
    "Выберите хотя бы один шаблон или загрузите дополнительный файл.",
  "documentBatch.packageTemplatesRequired":
    "Выберите шаблон основного файла и хотя бы один шаблон дополнительного файла.",
  "documentBatch.targetProcessRequired":
    "Хотя бы один процесс должен быть назначен выбранному сотруднику.",
  "documentBatch.limitExceeded":
    "За одну операцию можно создать не более 500 документов.",
  "documentBatch.fileLimitExceeded":
    "За одну операцию можно сгенерировать не более 500 файлов.",
  "documentBatch.deadlinePast": "Срок процесса не может быть в прошлом.",
  "documentBatch.resetFieldsConfirm":
    "Настройки изменены. Заполненные данные шага 2 будут удалены. Продолжить?",
  "documentBatch.subFileUnsupported":
    "Выбранная категория требует дополнительный файл. Для массового создания выберите категорию без обязательного дополнительного файла.",
  "documentBatch.packageCategoryUnsupported":
    "Выбранная категория не поддерживает основной и дополнительные файлы.",
  "documentBatch.descriptionRequired":
    "Для выбранной категории необходимо заполнить описание.",
  "documentBatch.priceRequired":
    "Для выбранной категории необходимо заполнить сумму.",
  "documentBatch.esedoUnsupported":
    "Выбранная категория требует индивидуального выбора данных ЕСЭДО и не подходит для этой массовой операции.",
  "documentBatch.prepareError":
    "Не удалось подготовить поля массовой операции.",
  "documentBatch.profileMismatch":
    "Не для всех выбранных сотрудников удалось получить доступные данные профиля.",
  "documentBatch.fillField": "заполните поле",
  "documentBatch.invalidFields": "проверьте поля:",
  "documentBatch.unresolvedTags": "в шаблоне остались незаполненные теги:",
  "documentBatch.invalidTitle": "проверьте шаблон названия документа.",
  "documentBatch.titleTooLong":
    "сформированное название документа не должно превышать 500 символов.",
  "documentBatch.probationDatesInvalid":
    "дата окончания испытательного срока раньше даты начала.",
  "documentBatch.contractDatesInvalid":
    "дата окончания договора раньше даты начала работы.",
  "documentBatch.startError": "Не удалось запустить массовое создание.",
  "documentBatch.itemError": "Не удалось создать документ.",
  "permission.hrView": "HR: просмотр личных дел",
  "permission.hrEmployeeEdit": "HR: управление сотрудниками",
  "permission.hrDocumentManage": "HR: управление документами сотрудников",
  "permission.hrSettingsManage": "HR: настройка перечня документов",
  "permission.hrAssistantEmployeeSearch": "Чатбот HR: поиск сотрудников",
  "permission.hrAssistantEmployeeView":
    "Чатбот HR: выбор и просмотр сотрудника",
  "permission.hrAssistantDocumentSearch": "Чатбот HR: поиск документов",
  "permission.hrAssistantDocumentView":
    "Чатбот HR: просмотр сведений о документах",
  "permission.hrAssistantFileView": "Чатбот HR: открытие файлов документов",
  "hr.assistantAccessTitle": "Доступ чатбота к HR",
  "hr.assistantUnclassifiedDocuments":
    "Разрешить доступ к нераспределённым файлам",
  "hr.assistantUnclassifiedHint":
    "Выключено по умолчанию. Сохраняются область доступа роли и права на поиск, просмотр и открытие файлов. Для файлов с назначенной категорией также действует список разрешённых категорий.",
  "hr.assistantAccessHint":
    "Настройки ограничивают каждую роль текущей компании. Права роли и область данных должны быть разрешены одновременно.",
  "hr.assistantRole": "Роль",
  "hr.assistantChooseRole": "Выберите роль",
  "hr.assistantEnabled": "Разрешить этой роли HR-поиск в чатботе",
  "hr.assistantRolePermissions": "Разрешённые действия роли",
  "hr.assistantNoPermissions":
    "У роли нет прав чатбота. Назначьте необходимые права в настройках роли.",
  "hr.assistantEmployeeScope": "Доступные сотрудники",
  "hr.assistantScopeSelf": "Только свои документы",
  "hr.assistantScopeCompany": "Сотрудники своей организации",
  "hr.assistantScopeSelected": "Только выбранные сотрудники",
  "hr.assistantScopeTenant": "Все сотрудники текущей компании SaaS",
  "hr.assistantEmployeeSearch": "Найти и добавить сотрудника",
  "hr.assistantDocumentTypes": "Доступные категории документов",
  "hr.assistantSelectAllDocumentTypes": "Выбрать все категории",
  "hr.assistantDocumentTypesHint":
    "Если ничего не выбрано, документы через чатбот недоступны.",
  "hr.assistantAccessLoadError":
    "Не удалось загрузить настройки доступа чатбота.",
  "hr.assistantAccessSaveError":
    "Не удалось сохранить настройки доступа чатбота.",
  "hr.employees": "Сотрудники",
  "hr.employeesHint": "Личные дела и комплектность документов сотрудников",
  "hr.module": "HR модуль",
  "hr.selectAllEmployees":
    "Выбрать всех действующих сотрудников раздела по текущим фильтрам",
  "documentList.loadError": "Не удалось загрузить список. Повторите поиск.",
  "rolePermissions.companies": "Компании",
  "rolePermissions.users": "Пользователи",
  "rolePermissions.categories": "Категории документов",
  "rolePermissions.documents": "Документы и шаблоны",
  "rolePermissions.coordination": "Координирование",
  "rolePermissions.reports": "Отчёты",
  "rolePermissions.hr": "HR модуль",
  "rolePermissions.assistant": "Чатбот HR",
  "rolePermissions.helpdesk": "Helpdesk",
  "rolePermissions.enbek": "Enbek",
  "rolePermissions.other": "Другие доступы",
  "hr.settings": "Настройки HR",
  "hr.allMatchingSelected":
    "Выбраны все доступные действующие сотрудники по текущим фильтрам",
  "hr.employeeTypeUnavailable":
    "Не настроен тип занятости для выбранного раздела HR",
  "hr.bulkPartial":
    "Операция частично выполнена. Обработано сотрудников: {count}. Повторное подтверждение продолжит оставшуюся часть.",
  "hr.documentTypes": "Перечень документов",
  "hr.esignLink": "Привязка eSign",
  "hr.allowEsignLink": "Разрешить привязку исполненного документа eSign",
  "hr.esignLinkHint":
    "Позволяет выбрать исполненный документ eSign вместо загрузки файла. Это разрешение, а не признак наличия документа.",
  "hr.documentTypesHint":
    "Настройка обязательных и необязательных документов личного дела",
  "hr.addEmployee": "Добавить сотрудника",
  "hr.editEmployee": "Редактировать сотрудника",
  "hr.searchEmployee": "ФИО, ИИН или табельный номер",
  "hr.all": "Все",
  "hr.completeness": "Заполненность",
  "hr.missing": "Не хватает",
  "hr.actions": "Действия",
  "hr.notConfigured": "Перечень не настроен",
  "hr.loading": "Загрузка…",
  "hr.saving": "Сохранение…",
  "hr.uploading": "Загрузка файла…",
  "hr.searching": "Поиск…",
  "hr.linking": "Привязка…",
  "hr.archiving": "Архивирование…",
  "hr.retry": "Повторить",
  "hr.backToEmployees": "Вернуться к сотрудникам",
  "hr.loadError": "Не удалось загрузить данные HR-модуля.",
  "hr.employeeLoadError": "Не удалось загрузить личное дело сотрудника.",
  "hr.employeeFormLoadError":
    "Не удалось загрузить данные сотрудника, необходимые для редактирования.",
  "hr.refreshError":
    "Операция выполнена, но не удалось обновить личное дело. Попробуйте перезагрузить страницу.",
  "hr.saveError": "Не удалось сохранить данные.",
  "hr.uploadError": "Не удалось загрузить документ.",
  "hr.archive": "Архивировать",
  "hr.archiveEmployeeConfirm": "Архивировать личное дело сотрудника?",
  "hr.archiveDocumentConfirm": "Архивировать документ сотрудника?",
  "hr.archiveTypeConfirm": "Архивировать тип документа?",
  "hr.statusActive": "Работает",
  "hr.statusDismissed": "Уволен",
  "hr.statusArchived": "Архив",
  "hr.statusService": "Служебный",
  "hr.surname": "Фамилия",
  "hr.name": "Имя",
  "hr.middleName": "Отчество",
  "hr.personnelNumber": "Табельный номер",
  "hr.phone": "Телефон",
  "hr.esignAccount": "Учетная запись eSign",
  "hr.employmentType": "Тип занятости",
  "hr.hireDate": "Дата приёма",
  "hr.dismissalDate": "Дата увольнения",
  "hr.note": "Примечание",
  "hr.personalDocuments": "Документы личного дела",
  "hr.residentialAddress": "Фактический адрес проживания",
  "hr.notSpecified": "Не указан",
  "hr.employeeNotifications": "Уведомления сотруднику",
  "hr.requestDocumentsHint":
    "Запросите недостающие документы на email сотрудника. Перед отправкой можно проверить список и текст письма.",
  "hr.recipient": "Получатель",
  "hr.emailMissingProfile": "Email не указан — добавьте его в профиле",
  "hr.reminderLabel": "Напоминать сотруднику о сроках",
  "hr.reminderHint":
    "Отправлять email перед окончанием срока документа и при просрочке. Само включение письма не отправляет.",
  "hr.enabled": "Включено",
  "hr.disabled": "Выключено",
  "hr.notificationHistory": "История уведомлений",
  "hr.notificationHistoryHint": "Последние 5 уведомлений и их текущий статус",
  "hr.refreshing": "Обновление…",
  "hr.noNotifications": "Уведомлений пока нет.",
  "hr.notificationDate": "Дата",
  "hr.notificationReason": "Причина",
  "hr.documentRequestNotification": "Запрос документов",
  "hr.expiryReminderNotification": "Напоминание о сроке",
  "hr.retryDelivery": "Повторить отправку",
  "hr.archiveEmployeeTitle": "Архивировать сотрудника?",
  "hr.archiveEmployeeHint": "Личное дело будет переведено в архив.",
  "hr.confirmArchiveEmployee": "Да, архивировать",
  "hr.employeeTypePlaceholder": "Выберите тип сотрудника",
  "hr.documentValidity": "Срок действия",
  "hr.documentPresence": "Наличие",
  "hr.fileCount": "Файлов:",
  "hr.documentPresent": "Документ имеется",
  "hr.add": "Добавить",
  "hr.unclassifiedFiles": "Нераспределённые файлы",
  "hr.fileName": "Наименование файла",
  "hr.noUnclassifiedFiles": "Нераспределённых файлов нет",
  "hr.chooseDocumentType": "Выберите тип",
  "hr.currentDocument": "Текущий документ",
  "hr.currentFile": "Текущий файл:",
  "hr.changeDatesOnlyHint":
    "Чтобы изменить только срок, не выбирайте новый файл.",
  "hr.uploadFile": "Загрузить файл",
  "hr.fromEsign": "Из eSign",
  "hr.chooseFile": "Выбрать файл",
  "hr.dropFile": "Перетащите файл сюда",
  "hr.clickChooseFile": "или нажмите, чтобы выбрать файл",
  "hr.clearFile": "Убрать выбранный файл",
  "hr.savingFile": "Загрузка и сохранение файла…",
  "hr.find": "Найти",
  "hr.unnumberedDocument": "Без номера",
  "hr.replacementHint":
    "Да, я хочу заменить имеющийся документ этого типа. Прежние файлы будут сохранены в архиве.",
  "hr.deleteDocumentTitle": "Удалить документ?",
  "hr.deleteDocumentHint":
    "Документ исчезнет из личного дела и будет сохранён в архиве.",
  "hr.deleting": "Удаление…",
  "hr.confirmDeleteDocument": "Да, удалить",
  "hr.classifyDocument": "Определить тип документа",
  "hr.addFile": "Добавить файл",
  "hr.updateDocument": "Обновить документ",
  "hr.addDocument": "Добавить документ",
  "hr.document": "Документ",
  "hr.kilobytes": "КБ",
  "hr.megabytes": "МБ",
  "hr.metadataOnly": "Локально доступны только метаданные",
  "hr.download": "Скачать",
  "hr.analytics": "Аналитика HR",
  "hr.analyticsMetric.employment.CONTRACT": "Сотрудники по ТД",
  "hr.analyticsMetric.employment.GPH": "Сотрудники по ГПХ",
  "hr.analyticsMetric.employees.total": "Всего сотрудников",
  "hr.analyticsMetric.field.email": "Указан email",
  "hr.analyticsMetric.field.phone": "Указан телефон",
  "hr.analyticsMetric.field.iin": "Указан ИИН",
  "hr.analyticsMetric.field.personnelNumber": "Указан табельный номер",
  "hr.analyticsMetric.field.address": "Указан фактический адрес",
  "hr.analyticsMetric.field.job": "Указана должность",
  "hr.analyticsMetric.field.hireDate": "Указана дата приёма",
  "hr.analyticsMetric.field.user": "Есть учётная запись",
  "hr.analyticsMetric.docs.complete": "Обязательные документы заполнены",
  "hr.analyticsMetric.docs.missing": "Не хватает обязательных документов",
  "hr.analyticsMetric.docs.notConfigured": "Обязательный перечень не настроен",
  "hr.analyticsMetric.docs.withFiles": "Есть документы",
  "hr.analyticsMetric.docs.withoutFiles": "Нет документов",
  "hr.analyticsMetric.docs.unclassified": "Нераспределённые файлы",
  "hr.analyticsMetric.docs.expired": "Файлы с истёкшим сроком",
  "hr.analyticsMetric.docs.expiring": "Срок файлов истекает за 30 дней",
  "hr.analyticsConfigure": "Настроить отображение",
  "hr.analyticsHint": "Показатели по всем сотрудникам, соответствующим фильтрам. Настройка отображения общая для компании.",
  "hr.analyticsColumns": "Карточек в строке",
  "hr.analyticsMoveUp": "Переместить вверх",
  "hr.analyticsMoveDown": "Переместить вниз",
  "hr.analyticsSaveError": "Не удалось сохранить настройки",
  "hr.analyticsEmpty": "Показатели не выбраны. Настройте отображение панели.",
  "hr.show": "Показать",
  "hr.showDocument": "Показать документ",
  "hr.update": "Обновить",
  "hr.classify": "Определить",
  "hr.invalidFileFormat": "Недопустимый формат файла",
  "hr.chooseSingleFile": "Выберите один файл",
  "hr.documentSearchError": "Не удалось найти документы",
  "hr.documentSaveError": "Не удалось сохранить документ",
  "hr.documentDeleteError": "Не удалось удалить документ",
  "hr.group.certificates": "Справки",
  "hr.group.orders": "Приказы",
  "hr.group.applications": "Заявления",
  "hr.group.education": "Образование",
  "hr.group.other": "Остальные документы",
  "hr.notificationLanguage": "Язык уведомления",
  "hr.russianLanguage": "Русский",
  "hr.englishLanguage": "English",
  "hr.selectAll": "Выделить все",
  "hr.deselectAll": "Снять все",
  "hr.documentsHint": "Обязательные и дополнительные документы сотрудника",
  "hr.noDocumentTypes": "Перечень документов ещё не настроен.",
  "hr.required": "Обязательный",
  "hr.documentMissing": "Документ отсутствует",
  "hr.validUntil": "действует до",
  "hr.replace": "Заменить",
  "hr.upload": "Загрузить",
  "hr.linkEsign": "Привязать из eSign",
  "hr.view": "Просмотреть",
  "hr.downloadEsign": "Скачать документы eSign",
  "hr.downloadError": "Не удалось получить файл документа",
  "hr.uploadDocument": "Загрузка документа",
  "hr.issueDate": "Дата выдачи",
  "hr.expiryDate": "Срок действия",
  "hr.expiryDateRequired": "Укажите срок действия документа.",
  "hr.searchDocuments": "Название или регистрационный номер",
  "hr.noDocumentsFound": "Исполненные документы eSign не найдены.",
  "hr.untitledDocument": "Без названия",
  "hr.file": "Файл",
  "hr.addDocumentType": "Добавить тип",
  "hr.editDocumentType": "Редактировать тип документа",
  "hr.showArchived": "Показывать архивные",
  "hr.documentTypeName": "Название документа",
  "hr.expiryRequired": "Требуется срок действия",
  "hr.order": "Порядок",
  "hr.description": "Описание",
  "hr.mailSettings": "Почтовые уведомления HR",
  "hr.mailSettingsHint":
    "Настройки действуют только для текущей компании. Включение рассылки не отправляет письма существующим сотрудникам автоматически.",
  "hr.mailEnabled": "Разрешить отправку писем HR",
  "hr.requestMissingDocuments": "Запросить недостающие документы",
  "hr.companyMailDisabledHint": "Рассылка компании выключена.",
  "hr.mailSettingsChecking": "Проверяем настройки рассылки…",
  "hr.contactName": "Контактное лицо HR",
  "hr.contactEmail": "Email HR для передачи документов",
  "hr.contactPhone": "Телефон HR",
  "hr.settingsSaved": "Настройки сохранены",
  "hr.mailSettingsLoadError":
    "Не удалось загрузить настройки рассылки. Обновите страницу.",
  "hr.emailNotifications": "Email-уведомления",
  "hr.preparationReady": "Подготовка завершена",
  "hr.preparationPending": "Первичная подготовка не завершена",
  "hr.completePreparation": "Завершить подготовку",
  "hr.requestDocuments": "Запросить документы",
  "hr.optional": "Необязательный, при наличии",
  "hr.mailPrivacyHint":
    "В письме только названия документов и контакты HR. Сотрудник передаёт документы HR; доступа к личному делу и вложений в письме нет.",
  "hr.enableExpiry": "Включить контроль сроков",
  "hr.disableExpiry": "Выключить контроль сроков",
  "hr.expiryControl": "Контроль сроков документов",
  "hr.expiryScheduleHint":
    "Напоминания: за 30, 7 и 1 день, затем однократно после истечения. Проверка ежедневно в 09:00 по времени Казахстана. Уже просроченные документы тоже вызовут уведомление после включения.",
  "hr.previewMail": "Предварительный просмотр",
  "hr.mailRecipientCount": "Получателей",
  "hr.emailMissing": "Email не указан",
  "hr.mailProblem.EMAIL_INVALID": "Укажите корректный email сотрудника.",
  "hr.mailProblem.EMPLOYEE_INACTIVE":
    "Сотрудник или связанная учётная запись неактивны.",
  "hr.expiredDocuments": "Просроченных документов",
  "hr.upcomingDocuments": "Истекают в течение 30 дней",
  "hr.missingExpiryDates": "Не указан необходимый срок действия",
  "hr.noDocumentsToRequest":
    "Все выбранные документы уже загружены. Письмо не потребуется.",
  "hr.confirmSend": "Подтвердить отправку",
  "hr.mailActionError":
    "Не удалось выполнить действие с уведомлениями. Повторите попытку.",
  "hr.notificationActionSaved":
    "Действие сохранено. Необходимые письма будут обработаны фоновой очередью.",
  "hr.refreshDelivery": "Обновить состояние отправки",
  "hr.documentExpired": "Срок действия истёк",
  "hr.documentExpiring": "Срок действия скоро истекает",
  "hr.disableExpiryConfirm":
    "Выключить напоминания о сроках для этого сотрудника?",
  "hr.retryMailConfirm":
    "Повторить обработку этого уведомления? Новое письмо-дубликат создано не будет.",
  "hr.selectedEmployees": "Выбрано сотрудников",
  "hr.selectEmployees": "Выбрать активных сотрудников на этой странице",
  "hr.delivery.PENDING": "Ожидает передачи в почтовую очередь",
  "hr.delivery.QUEUED": "Принято почтовой очередью",
  "hr.delivery.DELIVERED": "Передано почтовому серверу",
  "hr.delivery.FAILED": "Ошибка передачи, запланирован повтор",
  "hr.delivery.DEAD": "Ошибка — требуется повторная попытка HR",
  "hr.delivery.CANCELLED": "Отменено",
  "hr.deliveryReason.MAIL_SERVICE_UNAVAILABLE":
    "Почтовый сервис временно недоступен.",
  "hr.deliveryReason.MAIL_STATUS_UNAVAILABLE":
    "Письмо принято почтовой очередью. Состояние отправки временно недоступно; проверка будет повторена.",
  "hr.deliveryReason.HR_RETRY_REQUESTED":
    "Повторная обработка по запросу HR запланирована.",
  "hr.deliveryReason.SMTP_RETRY":
    "Повторная попытка отправки почтовому серверу.",
  "hr.deliveryReason.MAIL_REQUEST_REJECTED":
    "Почтовый сервис отклонил запрос. Проверьте настройки интеграции.",
  "hr.deliveryReason.SMTP_FAILED":
    "Не удалось передать письмо почтовому серверу.",
  "hr.deliveryReason.DELIVERY_DISABLED":
    "Рассылка или контроль сроков выключены.",
  "hr.deliveryReason.EMPLOYEE_INACTIVE":
    "Сотрудник или его учётная запись неактивны.",
  "hr.deliveryReason.EMAIL_INVALID": "Некорректный email сотрудника.",
  "hr.deliveryReason.EMAIL_CHANGED":
    "Email сотрудника изменён. Сформируйте новый запрос.",
  "hr.deliveryReason.DOCUMENT_CHANGED":
    "Документ или этап напоминания уже изменились.",
  "hr.deliveryReason.DOCUMENTS_COMPLETE":
    "Запрашиваемые документы уже загружены.",
  "hr.deliveryReason.DOCUMENT_OR_RECIPIENT_CHANGED":
    "Уведомление больше не актуально: проверьте документы, получателя и настройки.",
  "permission.enbekManage": "Работа с регистрациями Enbek",
  "enbek.tab": "Enbek",
  "enbek.register": "Зарегистрировать в Enbek",
  "enbek.registration": "Регистрация трудового договора в Enbek",
  "enbek.newContract": "Новый трудовой договор",
  "enbek.employee": "Сотрудник",
  "enbek.employer": "Работодатель",
  "enbek.position": "Должность",
  "enbek.contractNumber": "Номер договора",
  "enbek.contractDate": "Дата договора",
  "enbek.beginDate": "Дата начала работы",
  "enbek.endDate": "Дата окончания",
  "enbek.contractTerm": "Код срока договора",
  "enbek.establishedPost": "Штатная должность",
  "enbek.establishedPostCode": "Код штатной должности",
  "enbek.partTime": "Код занятости",
  "enbek.remoteWork": "Код дистанционной работы",
  "enbek.workPlace": "Место работы",
  "enbek.workPlaceKato": "КАТО места работы",
  "enbek.workPlaceCountry": "Код страны места работы",
  "enbek.workingHours": "Код рабочего времени",
  "enbek.tariffRate": "Тарифная ставка",
  "enbek.electronicContract": "Код электронного договора",
  "enbek.externalId": "Номер регистрации Enbek",
  "enbek.period": "Период",
  "enbek.indefinite": "бессрочно",
  "enbek.saveDraft": "Сохранить черновик",
  "enbek.saveAndSend": "Сохранить и отправить",
  "enbek.send": "Отправить в Enbek",
  "enbek.saved": "Черновик Enbek сохранён",
  "enbek.saveError": "Не удалось сохранить данные Enbek",
  "enbek.sent": "Запрос отправлен в Enbek",
  "enbek.registered": "Договор зарегистрирован в Enbek",
  "enbek.sendError": "Enbek вернул ошибку. Подробности сохранены в карточке.",
  "enbek.noRegistrations": "У пользователя пока нет регистраций Enbek",
  "enbek.transportDisabled": "Данные можно заполнить и сохранить. Реальная отправка станет доступна после включения VPN и транспортного адаптера.",
  "enbek.status.draft": "Черновик",
  "enbek.status.sending": "Отправляется",
  "enbek.status.sent": "Отправлено",
  "enbek.status.registered": "Зарегистрировано",
  "enbek.status.rejected": "Отклонено",
  "enbek.status.technical_error": "Техническая ошибка",
  "hr.audit.title": "Журнал HR",
  "hr.audit.hint":
    "История зафиксированных действий и этапов отправки писем. Записи появляются после сохранения операции; старые действия до внедрения журнала не восстанавливаются.",
  "hr.audit.action": "Действие",
  "hr.audit.from": "Дата от (UTC)",
  "hr.audit.to": "Дата до (UTC)",
  "hr.audit.refresh": "Обновить",
  "hr.audit.empty": "Записей по выбранным фильтрам нет",
  "hr.audit.date": "Дата действия",
  "hr.audit.actor": "Кто выполнил",
  "hr.audit.employee": "Сотрудник",
  "hr.audit.result": "Результат",
  "hr.audit.details": "Сведения",
  "hr.audit.system": "Система",
  "hr.audit.smtpAttempt": "Попытка SMTP",
  "hr.audit.subject": "Объект",
  "hr.audit.related": "Связанный объект",
  "hr.audit.event": "Идентификатор события",
  "hr.audit.operation": "Идентификатор операции",
  "hr.audit.source": "Источник",
  "hr.audit.fields": "Изменённые поля",
  "hr.audit.recorded": "Записано в журнал",
  "hr.audit.pages": "Страницы журнала",
  "hr.audit.previous": "Назад",
  "hr.audit.next": "Далее",
  "hr.audit.processingError": "Ошибка обработки",
  "hr.audit.committed": "Операция сохранена",
  "hr.audit.invalidDates": "Начальная дата не должна быть позже конечной",
  "hr.audit.loadError": "Не удалось загрузить журнал HR. Повторите попытку.",
  "hr.audit.source.BASE": "HR / основная система",
  "hr.audit.source.NOTIFICATION": "Почтовый сервис",
  "hr.audit.action.EMPLOYEE_CREATED": "Создано личное дело",
  "hr.audit.action.EMPLOYEE_UPDATED": "Изменено личное дело",
  "hr.audit.action.EMPLOYEE_ARCHIVED": "Личное дело архивировано",
  "hr.audit.action.DOCUMENT_CREATED": "Добавлен документ",
  "hr.audit.action.DOCUMENT_UPDATED": "Изменён документ",
  "hr.audit.action.DOCUMENT_ARCHIVED": "Документ архивирован",
  "hr.audit.action.DOCUMENT_READ": "Файл получен для просмотра или скачивания",
  "hr.audit.action.DOCUMENT_TYPE_CREATED": "Добавлен тип документа",
  "hr.audit.action.DOCUMENT_TYPE_UPDATED": "Изменён тип документа",
  "hr.audit.action.DOCUMENT_TYPE_ARCHIVED": "Тип документа архивирован",
  "hr.audit.action.EMPLOYEE_TYPE_CREATED": "Добавлен тип сотрудника",
  "hr.audit.action.EMPLOYEE_TYPE_UPDATED": "Изменён тип сотрудника",
  "hr.audit.action.EMPLOYEE_TYPE_ARCHIVED": "Тип сотрудника архивирован",
  "hr.audit.action.REQUIREMENT_CREATED":
    "Добавлен документ в перечень типа сотрудника",
  "hr.audit.action.REQUIREMENT_UPDATED": "Изменено требование к документу",
  "hr.audit.action.REQUIREMENT_DELETED":
    "Удалён документ из перечня типа сотрудника",
  "hr.audit.action.SETTINGS_CREATED": "Созданы настройки рассылки",
  "hr.audit.action.SETTINGS_UPDATED": "Изменены настройки рассылки",
  "hr.audit.action.NOTIFICATION_CREATED": "Создано уведомление",
  "hr.audit.action.NOTIFICATION_UPDATED": "Изменилось состояние уведомления",
  "hr.audit.action.MAIL_UPDATED": "Почтовый этап уведомления",
  "hr.audit.field.user_id": "Связанный пользователь",
  "hr.audit.field.company_id": "Компания",
  "hr.audit.field.job_id": "Должность",
  "hr.audit.field.surname": "Фамилия",
  "hr.audit.field.name": "Имя / название",
  "hr.audit.field.middle_name": "Отчество",
  "hr.audit.field.full_name": "Полное имя",
  "hr.audit.field.iin": "ИИН",
  "hr.audit.field.personnel_number": "Табельный номер",
  "hr.audit.field.email": "Email",
  "hr.audit.field.phone": "Телефон",
  "hr.audit.field.employment_type": "Тип занятости",
  "hr.audit.field.employee_type_id": "Тип сотрудника",
  "hr.audit.field.hire_date": "Дата приёма",
  "hr.audit.field.dismissal_date": "Дата увольнения",
  "hr.audit.field.note": "Примечание",
  "hr.audit.field.status": "Статус",
  "hr.audit.field.preparation_completed": "Подготовка личного дела завершена",
  "hr.audit.field.expiry_notifications_enabled": "Напоминания о сроках",
  "hr.audit.field.employee_id": "Сотрудник",
  "hr.audit.field.document_type_id": "Тип документа",
  "hr.audit.field.source": "Источник документа",
  "hr.audit.field.file_guid": "Привязка файла",
  "hr.audit.field.esign_document_id": "Привязка документа eSign",
  "hr.audit.field.issue_date": "Дата выдачи",
  "hr.audit.field.expiry_date": "Срок действия",
  "hr.audit.field.created_by": "Автор добавления",
  "hr.audit.field.archived_at": "Дата архивирования",
  "hr.audit.field.description": "Описание",
  "hr.audit.field.is_required": "Обязательность",
  "hr.audit.field.requires_expiry_date": "Необходимость срока действия",
  "hr.audit.field.allows_esign_link": "Разрешение привязки eSign",
  "hr.audit.field.sort_order": "Порядок",
  "hr.audit.field.code": "Код типа",
  "hr.audit.field.enabled": "Рассылка включена",
  "hr.audit.field.contact_name": "Имя HR-контакта",
  "hr.audit.field.contact_email": "Email HR-контакта",
  "hr.audit.field.contact_phone": "Телефон HR-контакта",
  "hr.audit.field.notification_id": "Идентификатор уведомления",
  "hr.audit.field.notification_key": "Ключ операции уведомления",
  "hr.audit.field.type": "Тип уведомления",
  "hr.audit.field.document_type_ids": "Перечень документов",
  "hr.audit.field.document_id": "Документ",
  "hr.audit.field.reminder_days": "Этап напоминания",
  "hr.audit.field.initiated_by": "Инициатор",
  "hr.audit.field.recipient": "Получатель",
  "hr.audit.field.attempts": "Количество попыток",
  "hr.audit.field.reason_code": "Причина",
  "hr.audit.field.accepted_at": "Дата принятия в очередь",
  "hr.audit.field.delivered_at": "Дата передачи SMTP",
  "hr.audit.field.original_file_name": "Исходное имя файла",
  "hr.audit.field.source_path": "Источник импорта",
  "hr.audit.field.original_file_size": "Размер файла",
  "hr.audit.field.original_content_type": "Тип файла",
  "hr.audit.field.classification_confidence": "Результат классификации",
  "hr.audit.field.proposed_document_type_name": "Предложенный тип документа",
  "hr.audit.field.external_file": "Импортированный файл",
  "hr.audit.mail.PENDING": "Письмо в очереди SMTP",
  "hr.audit.mail.FAILED": "Ошибка передачи SMTP",
  "hr.audit.mail.DEAD": "Отправка завершилась ошибкой — требуется действие HR",
  "hr.audit.mail.DELIVERED": "Письмо принято SMTP-сервером",
  "hr.audit.mail.CANCELLED": "Отправка отменена",
};
